//user running.jsx
import React, { useEffect, useState, useRef } from "react";
import SignatureDialog from "./SignatureDialog";
import {
  postToInsuranceSalesforce,
  updateRecordInSalesforce,
  getRecordInfo,
  sendToSalesforce,
  fetchFormData,
  getAccountInfo,
  updateAccountInSalesforce,
  sendToSalesforceSign,
  linkToSalesforceSign
} from "./salesforce";
import { getForms } from "./api";
import logo from "./logo.png";
import { useLocation } from "react-router-dom";
import background from "./BG Shape_page-0001.jpg";
import DatePicker from "react-datepicker";
import { useParams, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import html2pdf from "html2pdf.js";
import { Toaster, toast } from "react-hot-toast";
import MultiSelect from './MultiSelect';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import './fonts.css';
import axios from 'axios';
import { AST_True } from "terser";
import GooglePlacesAutocomplete from 'react-google-autocomplete';


const LOG_URL = process.env.REACT_APP_CLIENT_LOG_URL
const User = () => {
  var autostate1 = true;
  const location = useLocation();
  const [autostate, setAutoState] = useState(true);
  const [savedForms, setSavedForms] = useState({});
  const [formData, setFormData] = useState({});
  const [accountData, setAccountData] = useState({});
  const [signatureRef, setSignatureRef] = useState(null);
  const [signatureRef1, setSignatureRef1] = useState(null);
  const [signaturevalue, setSignatureValue] = useState("");
  const [signaturevalue1, setSignatureValue1] = useState("");
  const [consentFlag, setConsentFlag] = useState(false);
  const [singleConsentFlag, setSingleConsentFlag] = useState(false);
  const [updateid, setUpdatedId] = useState(null);
  const [recordid, setRecordId] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [paperCount, setPaperCount] = useState(0);
  const [formDataObject, setFormDataObject] = useState({});
  const [accountDataObject, setAccountDataObject] = useState({});
  const [accountFormids, setAccountFormids] = useState([]);
  const [fillingFormId, setFillingFormId] = useState(null);
  const [changedFormIds, setChangedFormIds] = useState([]);
  const [normalFormIds, setNormalFormIds] = useState([]);
  const [consentFormIds, setConsentFormIds] = useState([]);
  const [formStatus, setFormStatus] = useState(null);
  const [consentForms, setConsentForms] = useState([]);
  const [normalForms, setnormalForms] = useState([]);
  const [userData, setUserData] = useState({});
  const [uploading, setUploading] = useState(false);
  const [terms, setTerms] = useState(false);
  const [singleTerms, setSingleTerms] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [okModal, setOkModal] = useState(false);
  const [continueModal, setContinueModal] = useState(false);
  const [language, setLanguage] = useState(location?.state?.lang);
  const [ok, setOk] = useState(null);
  const [saveSignature, setSaveSignature] = useState(true);
  const [checkboxChecked, setCheckboxChecked] = useState(Array(consentForms.length).fill(false));
  var updateid1;
  const { id } = useParams();
  const inputRefs = {};
  const autoCompleteRef = useRef();
  const inputRef = useRef();
  const options = {
    componentRestrictions: { country: "ng" },
    fields: ["address_components", "geometry", "icon", "name"],
    types: ["establishment"]
  };
  /* useEffect(() => {
    //autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      options
    );
  }, []);
 */  const auth = location?.state?.auth || false;
  //console.log(location.state);
  const navigate = useNavigate();
  let currentDate = new Date();
  const handlePlaceSelected = (place) => {
    console.log(place);
    // Handle the selected place object here
  };
  const minDate = new Date(currentDate.getFullYear() - 100, currentDate.getMonth(), currentDate.getDate()); // Calculate date 100 years ago
  const minDateString = minDate.toISOString().split('T')[0]; // Get min date in yyyy-mm-dd format
  const maxDate = new Date().toISOString().split('T')[0];
  let dd = currentDate.getDate();
  let mm = currentDate.getMonth() + 1;
  let yyyy = currentDate.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  currentDate = mm + "-" + dd + "-" + yyyy;
  //console.log(currentDate);
  useEffect(() => {
    // If auth is not true, redirect to home page
    if (auth != true) {
      navigate(`/${id}`);
    } else {

      if (id) fetchPatientData();
      // const userData = location.state.userData || {};
      // setUserData(userData);
    }
  }, [auth, id]);
  function Changelanguage(a) {
    setLanguage(a)
  }
  const fetchIpAddress = async () => {
    try {
      const response = await axios.get('https://api.ipify.org?format=json');
      return response.data.ip;
    } catch (error) {
      console.error('Error fetching IP address:', error);
      logEvent('IP address tracking failed');
      return null;
    }
  };
  const fetchPatientData = async () => {
    try {
      const response = await getAccountInfo(id);

      setUserData(response.data);

    } catch (error) {
      console.error("Error fetching patient data:", error);
    }
  };
  {/*console.log(userData)*/ }
  var pdfforms;
  useEffect(() => {
    fetchformdata();
    const storedSignature = localStorage.getItem("usersignature");
    //console.log(storedSignature);
    if (storedSignature != 'undefined' && storedSignature != "" && storedSignature != 'null' && storedSignature != null) {
      let parsedSignature = JSON.parse(storedSignature);

      //console.log(parsedSignature);
      setSignatureValue(parsedSignature);
    } else {
      setSignatureValue("");
    }
  }, []);
  async function fetchformdata() {
    try {
      const res = await getForms();
      if (res) {
        //console.log(res);
        // Separate forms into consent and non-consent arrays
        const consentForms = res.filter(form => form.consent == 1);
        const nonConsentForms = res.filter(form => form.consent != 1);
        //setForms(res);
        setConsentForms(consentForms);
        setnormalForms(nonConsentForms);
        //console.log(nonConsentForms);
        pdfforms = nonConsentForms;
      }
    } catch (error) {
      console.error('Error fetching forms:', error);
    }
  }
  useEffect(() => {
    getRecordInfo1();
  }, []);
  const isEmpty = (obj) => Object.keys(obj).length === 0;
  /*   useEffect(() => {
      if ((isEmpty(formData) && isEmpty(accountData)) || changedFormIds.length === 0) {
  
        return;
      }
      var intervalId = setTimeout(myFunction, 12000); // 120000 milliseconds = 2 minutes
  
      return () => {
        //console.log(`Clearing interval for accountId: ` + intervalId);
        clearInterval(intervalId);
      };
    }, [formData, accountData]); // Depend on accountId to re-run the effect when it changes
   */
  const myFunction = async () => {
    if (!consentFlag) {
      for (const form_id of normalFormIds) {
        await autosaving(form_id, 1);
      }
    } else {
      for (const form_id of consentFormIds) {
        await autosaving(form_id, 2);
      }
    }
  };
  function logout(e) {
    e.preventDefault();
    navigate(`/${id}`);
  }
  function logout1(e) {
    logEvent('User clicked ok - redirected to Alliance Ortho Home page');
    e.preventDefault();
    window.location.replace('https://allianceortho.com/')

    setOkModal(false);
  }
  const getRecordInfo1 = async () => {
    try {
      const response = await getRecordInfo(id);
      const response1 = await getAccountInfo(id);
      if (response == 1) {
        setPaperCount(0);
        setFormDataObject({});
        setFormData({});
        setUpdatedId(null);
        handleClear1();
      } else {
        setFormDataObject(response);
        setContinueModal(true);
        setAccountDataObject(response1.data)
        updateid1 = response.Id;
        setUpdatedId(response.Id);
        setPaperCount(response.HQ_Paperwork_Status__c);
      }
    } catch (error) {
      console.error("Error fetching patient data:", error);
      logEvent('Error fetching patient data');
    }
  };

  const getRecordInfo2 = async () => {
    try {
      const response = await getRecordInfo(id);
      const response1 = await getAccountInfo(id);
      if (response == 1) {
        setPaperCount(0);
        setFormDataObject({});
        setFormData({});
        setUpdatedId(null);
      } else {
        setFormDataObject(response);
        setAccountDataObject(response1.data)
        updateid1 = response.Id;
        setUpdatedId(response.Id);
        setPaperCount(response.HQ_Paperwork_Status__c);
      }
    } catch (error) {
      console.error("Error fetching patient data:", error);
      logEvent('Error fetching patient data');
    }
  };
  const validateField = (element) => {
    return "";
  };
  const updateCheckboxState = (index) => {
    const updatedForms = [...consentForms];
    updatedForms[index].checked = !updatedForms[index].checked;
    setConsentForms(updatedForms);
    const displayedForms = updatedForms.filter(form => form.formConditional != '1');
    const allChecked = displayedForms.every((form) => form.checked);
    logEvent('Single Check boxes Checked');
    setSingleTerms(allChecked);
  };
  const handleChange = (e, element, index, formid, a) => {
    const { name, value } = e.target;
    var form_id = Number(formid);
    if (index == 'p') {
      setAccountFormids((prevChangedFormIds) => {
        if (!prevChangedFormIds.includes(form_id)) {
          return [...prevChangedFormIds, form_id];
        } else {
          return prevChangedFormIds;
        }
      })
      setAccountData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }))
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));

    }
    setChangedFormIds((prevChangedFormIds) => {
      if (!prevChangedFormIds.includes(form_id)) {
        return [...prevChangedFormIds, form_id];
      } else {
        return prevChangedFormIds;
      }
    });
    if (a == 1) {
      setNormalFormIds((prevChangedFormIds) => {
        if (!prevChangedFormIds.includes(form_id)) {
          return [...prevChangedFormIds, form_id];
        } else {
          return prevChangedFormIds;
        }
      });
    } else if (a == 2) {
      setConsentFormIds((prevChangedFormIds) => {
        if (!prevChangedFormIds.includes(form_id)) {
          return [...prevChangedFormIds, form_id];
        } else {
          return prevChangedFormIds;
        }
      });
    }
  };
  const handleChange1 = (e, element) => {
    const { name, value } = e.target;
    if (element.isConditional) {
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleChangeDate = (date, fieldName, formId) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: date.toISOString().split("T")[0],
    }));
    var form_id = Number(formId) + 1;
    // Check if the current formId is not already in the changedFormIds array
    setChangedFormIds((prevChangedFormIds) => {
      if (!prevChangedFormIds.includes(form_id)) {
        // If not included, return a new array with the formId added
        return [...prevChangedFormIds, form_id];
      } else {
        // If already included, just return the previous array without changes
        return prevChangedFormIds;
      }
    });
  };
  const handleCheckboxChange = (fieldName, selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: selectedOption,
    }));
  };
  const scrollToField = (fieldName) => {
    // Find the target element using its id or class
    const targetElement = document.getElementById(fieldName);
    // Scroll to the target element
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop,
        behavior: 'smooth'
      });
    }
  };
  const handleSubmit = (e, a) => {
    e.preventDefault();
    setAutoState(false);
    autostate1 = false;
    if (a == 2) {
      if (!saveSignature) {
        toast.error("Please Sign and Click on Save Button to Proceed");
        return;
      }
    }
    submitForm(e, a);
    if (a === 1) {
      axios.post(LOG_URL, {
        message: 'User Submitted Non consent - ' + formData.HQ_Patient_Name__c
      }).then(response => {
        console.log('Non Consent log recorded:', response.data);
      }).catch(error => {
        console.error('Error logging in:', error);
      });
      logEvent('Form 1 is Submitted');
    } else if (a === 2) {
      axios.post(LOG_URL, {
        message: 'User Submitted consent - ' + formData.HQ_Patient_Name__c
      }).then(response => {
        console.log('Consent log recorded:', response.data);
      }).catch(error => {
        console.error('Error logging in:', error);
      });
    }
  }
  const handleSaveSignature = (e) => {
    e.preventDefault();
    const signatureData = signatureRef?.toDataURL();
    setSignatureValue(signatureData);
    localStorage.setItem("usersignature", JSON.stringify(signatureData));
    setSignatureRef(null);
    setSaveSignature(true);
    axios.post(LOG_URL, {
      message: 'User Sign Recorded - ' + formData.HQ_Patient_Name__c
    }).then(response => {
      console.log('User Sign Recorded:', response.data);
    }).catch(error => {
      console.error('User Sign Not Recorded:', error);
    });
  }
  const logEvent = async (eventName) => {
    const ipAddress = await fetchIpAddress();
    axios.post(LOG_URL, {
      message: `${eventName}`,
      username: formData.HQ_Patient_Name__c,
      patient_id: id,
      ipAddress: ipAddress
    })
      .then(response => {
        console.log(`Event logged: ${eventName}`, response.data);
      })
      .catch(error => {
        console.error(`Error logging event: ${eventName}`, error);
      });
  };

  const submitForm = async (e, a) => {
    var signatureData1;
    if (a == 2) {
      if (!singleTerms) {
        {
          language == 1 ? (
            toast.error("Please Accept Terms & Conditions")
          ) : (
            toast.error("Por favor acepte los términos y condiciones")
          )
        }
        logEvent('Single Check boxes');
        return;
      }
      if (!terms) {
        {
          language == 1 ? (
            toast.error("Please Accept Consent")
          ) : (
            toast.error("Por favor acepte el consentimiento")
          )
        }
        logEvent('Consent Check Box');
        return;
      }
      if (!signaturevalue) {
        if (signatureRef && signatureRef.isEmpty()) {
          {
            language == 1 ? (
              toast.error("Please sign the form")
            ) : (
              toast.error("Por favor firme el formulario")
            )
          }
          logEvent('Signature Event');
          setUploading(false);

          return;
        } else {

          const signatureData = signatureRef?.toDataURL();
          signatureData1 = signatureRef?.toDataURL();
          setSignatureValue(signatureData);
          localStorage.setItem("usersignature", JSON.stringify(signatureData));
          setSignatureRef(null);
        }
      }
      else {
        signatureData1 = signaturevalue
      }
      // Check if signatureData is available
      var base64Data = signatureData1;
      var parts = base64Data.split(',');
      const stripSignurl = parts[1]; // Remove the data URL prefix
      if (stripSignurl) {
        try {
          console.log(stripSignurl);
          if (updateid) {
            updateid1 = updateid;
          }
          console.log(updateid1);
          // Call sendToSalesforceSign to send the signature to Salesforce
          const timestamp = Date.now();
          const uniqueIdentifier = Math.random().toString(36).substring(7); // Generate a random string
          const signatureName = `Signature_${timestamp}_${uniqueIdentifier}`;
          const res = await sendToSalesforceSign(stripSignurl, signatureName, updateid1);
          if (res) {
            formData.HQ_Sign_Id__c = res?.id;
          }
          logEvent('Signature sent to sales force');
          handleClear1();
          console.log("Signature linked to Salesforce record successfully!");
        } catch (error) {
          logEvent('Salesforce connection error');
          console.error("Error sending or linking signature to Salesforce:", error);
          // Handle error accordingly
        }
      } else {
        console.error("No signature data available!");
        // Handle the case where signature data is not available
      }
    }
    const largestFormId = Math.max(...changedFormIds);
    let errorMessages = {};
    let errors = false;
    {
      if (a == 1) {
        if (!formData || !formDataObject || !accountData && !accountDataObject) {
          {
            language == 1 ? (
              toast.error(`Please Fill Atleast One Form Element`)
            ) : (
              toast.error("Complete al menos un elemento del formulario")
            )
          }
          return;
        }
        normalForms.forEach((form) => {
          JSON.parse(form.formelements).forEach((element) => {
            let value = '';
            if (formData && formData[element.selectedOption]) {
              value = formData[element.selectedOption];
            } else if (accountData && accountData[element.selectedOption]) {
              value = accountData[element.selectedOption]
            }
            else if (formDataObject && formDataObject[element.selectedOption]) {
              value = formDataObject[element.selectedOption];
            } else if (accountDataObject && accountDataObject[element.selectedOption]) {
              value = accountDataObject[element.selectedOption];
            }
            let errorMessage = "";
            let errorMessage1 = "";
            if (element.isMandatory && (value === undefined || value === "")) {
              // errorMessage1 = `Please Fill ${element.name} <a href="${element.selectedOption}">Click here</a>`;
              const targetElement = document.getElementById(element.selectedOption);
              //console.log(targetElement);
              errorMessage1 = `Please Fill ${element.name}`;
              toast.custom(
                <div
                  style={{
                    fontSize: "17px",
                    display: "flex",
                    alignItems: "center",
                    background: "#fff",
                    color: "#363636",
                    lineHeight: "1.3",
                    willChange: "transform",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                    maxWidth: "350px",
                    pointerEvents: "auto",
                    padding: "14px 18px",
                    borderRadius: "8px",
                  }}
                  onClick={(e) => {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }}
                >
                  {errorMessage1}
                </div>
                ,
                { duration: 20000 }
              );
              errors = true;
              return;
            } else if (value !== undefined && value !== "") {
              switch (element.validationType) {
                case "email":
                  if (!/\S+@\S+\.\S+/.test(value)) {
                    {
                      language == 1 ? (
                        errorMessage = "Please enter a valid email"
                      ) : (
                        errorMessage = "Por favor introduzca una dirección de correo electrónico válida"
                      )
                    }
                    setValidationErrors(errorMessages);
                    errors = true;
                    const targetElement = document.getElementById(element.selectedOption);
                    toast.custom(
                      <div
                        style={{
                          fontSize: "17px",
                          display: "flex",
                          alignItems: "center",
                          background: "#fff",
                          color: "#363636",
                          lineHeight: "1.3",
                          willChange: "transform",
                          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                          maxWidth: "350px",
                          pointerEvents: "auto",
                          padding: "14px 18px",
                          borderRadius: "8px",
                        }}
                        onClick={(e) => {
                          targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }}
                      >
                        {errorMessage}
                      </div>
                    );
                    return;
                  }
                  break;
                case "number":
                  if (element.selectedOption == 'HQ_Credit_Card_Number__c') {
                    if (accountData['HQ_Credit_Card_Type__c']
                      ? accountData['HQ_Credit_Card_Type__c'] == 'American Express'
                      : accountDataObject['HQ_Credit_Card_Type__c'] ==
                      'American Express') {

                      if (!/^[0-9]{15}$/.test(value)) {
                        {
                          language == 1 ? (
                            errorMessage = "Please enter a valid number (15 digits)"
                          ) : (
                            errorMessage = "Por favor ingrese un número válido (15 dígitos)"
                          )
                        }
                        errors = true;
                        const targetElement = document.getElementById(element.selectedOption);
                        //console.log(targetElement);
                        toast.custom(
                          <div
                            style={{
                              fontSize: "17px",
                              display: "flex",
                              alignItems: "center",
                              background: "#fff",
                              color: "#363636",
                              lineHeight: "1.3",
                              willChange: "transform",
                              boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                              maxWidth: "350px",
                              pointerEvents: "auto",
                              padding: "14px 18px",
                              borderRadius: "8px",
                            }}
                            onClick={(e) => {
                              targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }}
                          >
                            {errorMessage}
                          </div>
                        );
                      }
                    } else {
                      if (!/^[0-9]{16}$/.test(value)) {
                        {
                          language == 1 ? (
                            errorMessage = "Please enter a valid  number (16 digits)"
                          ) : (
                            errorMessage = "Por favor ingrese un número válido (16 dígitos)"
                          )
                        }
                        errors = true;
                        const targetElement = document.getElementById(element.selectedOption);
                        //console.log(targetElement);
                        toast.custom(
                          <div
                            style={{
                              fontSize: "17px",
                              display: "flex",
                              alignItems: "center",
                              background: "#fff",
                              color: "#363636",
                              lineHeight: "1.3",
                              willChange: "transform",
                              boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                              maxWidth: "350px",
                              pointerEvents: "auto",
                              padding: "14px 18px",
                              borderRadius: "8px",
                            }}
                            onClick={(e) => {
                              targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }}
                          >
                            {errorMessage}
                          </div>
                        );

                      }
                    }
                  } else {
                    if (isNaN(value)) {
                      {
                        language == 1 ? (
                          <label className="question">Patient Name</label>
                        ) : (
                          <label className="question">Nombre del Paciente</label>
                        )
                      }
                      errorMessage = "Please enter a valid number";
                      errors = true;
                      const targetElement = document.getElementById(element.selectedOption);
                      toast.custom(
                        <div
                          style={{
                            fontSize: "17px",
                            display: "flex",
                            alignItems: "center",
                            background: "#fff",
                            color: "#363636",
                            lineHeight: "1.3",
                            willChange: "transform",
                            boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                            maxWidth: "350px",
                            pointerEvents: "auto",
                            padding: "14px 18px",
                            borderRadius: "8px",
                          }}
                          onClick={(e) => {
                            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                          }}
                        >
                          {errorMessage}
                        </div>
                      );
                    }
                  }
                  break;
                case "phone":
                  if (!/^[0-9]{10}$/.test(value)) {
                    {
                      language == 1 ? (
                        errorMessage = "Please enter a valid phone number (10 digits)"
                      ) : (
                        errorMessage = "Por favor ingrese un número de teléfono válido (10 dígitos)"
                      )
                    }
                    errorMessages[element.selectedOption] = errorMessage;
                    setValidationErrors(errorMessages);
                    const targetElement = document.getElementById(element.selectedOption);
                    toast.custom(
                      <div
                        style={{
                          fontSize: "17px",
                          display: "flex",
                          alignItems: "center",
                          background: "#fff",
                          color: "#363636",
                          lineHeight: "1.3",
                          willChange: "transform",
                          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                          maxWidth: "350px",
                          pointerEvents: "auto",
                          padding: "14px 18px",
                          borderRadius: "8px",
                        }}
                        onClick={(e) => {
                          targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }}
                      >
                        {errorMessage}
                      </div>
                    );
                    errors = true;
                    return;
                  }
                  break;

                case "cvv":
                  const cvvValue = value;
                  if (accountData['HQ_Credit_Card_Type__c']
                    ? accountData['HQ_Credit_Card_Type__c'] == 'American Express'
                    : accountDataObject['HQ_Credit_Card_Type__c'] ==
                    'American Express') {
                    if (!/^[0-9]{4}$/.test(cvvValue)) {
                      errorMessage = "Please enter a valid CVV (4 digits)";
                      const targetElement = document.getElementById(element.selectedOption);
                      //console.log(targetElement);
                      errorMessages[element.selectedOption] = errorMessage;
                      setValidationErrors(errorMessages);
                      toast.custom(
                        <div
                          style={{
                            fontSize: "17px",
                            display: "flex",
                            alignItems: "center",
                            background: "#fff",
                            color: "#363636",
                            lineHeight: "1.3",
                            willChange: "transform",
                            boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                            maxWidth: "350px",
                            pointerEvents: "auto",
                            padding: "14px 18px",
                            borderRadius: "8px",
                          }}
                          onClick={(e) => {
                            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                          }}
                        >
                          {errorMessage}
                        </div>
                      );
                      errors = true;
                    }
                  } else {
                    if (!/^[0-9]{3}$/.test(cvvValue)) {
                      errorMessage = "Please enter a valid CVV (3 digits)";
                      const targetElement = document.getElementById(element.selectedOption);
                      //console.log(targetElement);
                      toast.custom(
                        <div
                          style={{
                            fontSize: "17px",
                            display: "flex",
                            alignItems: "center",
                            background: "#fff",
                            color: "#363636",
                            lineHeight: "1.3",
                            willChange: "transform",
                            boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                            maxWidth: "350px",
                            pointerEvents: "auto",
                            padding: "14px 18px",
                            borderRadius: "8px",
                          }}
                          onClick={(e) => {

                            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                          }}
                        >
                          {errorMessage}
                        </div>
                      );
                      errors = true;

                    }

                  }


                  break;
                case "ssn":
                  if (!/^[0-9]{9}$/.test(value)) {
                    errorMessage =
                      "Please enter a valid ssn number (9 digits)";
                    errorMessages[element.selectedOption] = errorMessage;
                    setValidationErrors(errorMessages);
                    const targetElement = document.getElementById(element.selectedOption);
                    //console.log(targetElement);


                    toast.custom(
                      <div
                        style={{
                          fontSize: "17px",
                          display: "flex",
                          alignItems: "center",
                          background: "#fff",
                          color: "#363636",
                          lineHeight: "1.3",
                          willChange: "transform",
                          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                          maxWidth: "350px",
                          pointerEvents: "auto",
                          padding: "14px 18px",
                          borderRadius: "8px",
                        }}
                        onClick={(e) => {

                          targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }}
                      >
                        {errorMessage}
                      </div>
                    );
                    errors = true;
                    return;
                  }
                  break;
                default:
                  // Handle unknown validationType or no specific validation required
                  break;
              }
            }
          });

        });
        if (errors) {
          return;
        }
      } else {
        consentForms.forEach((form) => {
          JSON.parse(form.formelements).forEach((element) => {
            let value = '';
            if (formData && formData[element.selectedOption]) {
              value = formData[element.selectedOption];
            } else if (accountData && accountData[element.selectedOption]) {
              value = accountData[element.selectedOption]
            }
            else if (formDataObject && formDataObject[element.selectedOption]) {
              value = formDataObject[element.selectedOption];
            } else if (accountDataObject && accountDataObject[element.selectedOption]) {
              value = accountDataObject[element.selectedOption];
            }

            let errorMessage = "";

            if (element.isMandatory && (value === undefined || value === "")) {
              errorMessage = `Please Fill ${element.name}`;
              const targetElement = document.getElementById(element.selectedOption);
              toast.custom(
                <div
                  style={{
                    fontSize: "17px",
                    display: "flex",
                    alignItems: "center",
                    background: "#fff",
                    color: "#363636",
                    lineHeight: "1.3",
                    willChange: "transform",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                    maxWidth: "350px",
                    pointerEvents: "auto",
                    padding: "14px 18px",
                    borderRadius: "8px",
                  }}
                  onClick={(e) => {

                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }}
                >
                  {errorMessage}
                </div>
              );
              errors = true;
              return;
            } else if (value !== undefined) {
              switch (element.validationType) {
                case "email":
                  if (!/\S+@\S+\.\S+/.test(value)) {
                    errorMessages[element.selectedOption] =
                      "Please enter a valid email";
                    errorMessage = "Please enter a valid email";
                    const targetElement = document.getElementById(element.selectedOption);
                    //console.log(targetElement);
                    toast.custom(
                      <div
                        style={{
                          fontSize: "17px",
                          display: "flex",
                          alignItems: "center",
                          background: "#fff",
                          color: "#363636",
                          lineHeight: "1.3",
                          willChange: "transform",
                          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                          maxWidth: "350px",
                          pointerEvents: "auto",
                          padding: "14px 18px",
                          borderRadius: "8px",
                        }}
                        onClick={(e) => {

                          targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }}
                      >
                        {errorMessage}
                      </div>
                    );
                    setValidationErrors(errorMessages);

                    errors = true;

                    return;
                  }
                  break;
                case "number":
                  if (element.selectedOption == 'HQ_Credit_Card_Number__c') {
                    if (accountData['HQ_Credit_Card_Type__c']
                      ? accountData['HQ_Credit_Card_Type__c'] == 'American Express'
                      : accountDataObject['HQ_Credit_Card_Type__c'] ==
                      'American Express') {

                      if (!/^[0-9]{15}$/.test(value)) {
                        errorMessage =
                          "Please enter a valid number (15 digits)";
                        errors = true;
                        const targetElement = document.getElementById(element.selectedOption);
                        //console.log(targetElement);
                        toast.custom(
                          <div
                            style={{
                              fontSize: "17px",
                              display: "flex",
                              alignItems: "center",
                              background: "#fff",
                              color: "#363636",
                              lineHeight: "1.3",
                              willChange: "transform",
                              boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                              maxWidth: "350px",
                              pointerEvents: "auto",
                              padding: "14px 18px",
                              borderRadius: "8px",
                            }}
                            onClick={(e) => {

                              targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }}
                          >
                            {errorMessage}
                          </div>
                        );
                      }
                    } else {
                      if (!/^[0-9]{16}$/.test(value)) {
                        errorMessage =
                          "Please enter a valid  number (16 digits)";
                        errors = true;
                        const targetElement = document.getElementById(element.selectedOption);
                        toast.custom(
                          <div
                            style={{
                              fontSize: "17px",
                              display: "flex",
                              alignItems: "center",
                              background: "#fff",
                              color: "#363636",
                              lineHeight: "1.3",
                              willChange: "transform",
                              boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                              maxWidth: "350px",
                              pointerEvents: "auto",
                              padding: "14px 18px",
                              borderRadius: "8px",
                            }}
                            onClick={(e) => {

                              targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }}
                          >
                            {errorMessage}
                          </div>
                        );
                      }
                    }
                  } else {
                    if (isNaN(value)) {
                      errorMessage = "Please enter a valid number";
                      //setValidationErrors(errorMessages);
                      errors = true;
                      const targetElement = document.getElementById(element.selectedOption);
                      toast.custom(
                        <div
                          style={{
                            fontSize: "17px",
                            display: "flex",
                            alignItems: "center",
                            background: "#fff",
                            color: "#363636",
                            lineHeight: "1.3",
                            willChange: "transform",
                            boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                            maxWidth: "350px",
                            pointerEvents: "auto",
                            padding: "14px 18px",
                            borderRadius: "8px",
                          }}
                          onClick={(e) => {

                            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                          }}
                        >
                          {errorMessage}
                        </div>
                      );
                    }
                  }
                  break;
                case "phone":
                  if (!/^[0-9]{10}$/.test(value)) {
                    errorMessages[element.selectedOption] =
                      "Please enter a valid phone number (10 digits)";
                    errorMessage =
                      "Please enter a valid phone number (10 digits)";
                    setValidationErrors(errorMessages);
                    // alert(errorMessage);
                    const targetElement = document.getElementById(element.selectedOption);
                    //console.log(targetElement);


                    toast.custom(
                      <div
                        style={{
                          fontSize: "17px",
                          display: "flex",
                          alignItems: "center",
                          background: "#fff",
                          color: "#363636",
                          lineHeight: "1.3",
                          willChange: "transform",
                          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                          maxWidth: "350px",
                          pointerEvents: "auto",
                          padding: "14px 18px",
                          borderRadius: "8px",
                        }}
                        onClick={(e) => {

                          targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }}
                      >
                        {errorMessage}
                      </div>
                    );
                    errors = true;
                    return;
                  }
                  break;
                case "cvv":
                  const cvvValue = value;
                  if (accountData['HQ_Credit_Card_Type__c']
                    ? accountData['HQ_Credit_Card_Type__c'] == 'American Express'
                    : accountDataObject['HQ_Credit_Card_Type__c'] ==
                    'American Express') {
                    if (!/^[0-9]{4}$/.test(cvvValue)) {
                      errorMessage = "Please enter a valid CVV (4 digits)";
                      const targetElement = document.getElementById(element.selectedOption);
                      //console.log(targetElement);
                      errorMessages[element.selectedOption] = errorMessage;
                      setValidationErrors(errorMessages);
                      toast.custom(
                        <div
                          style={{
                            fontSize: "17px",
                            display: "flex",
                            alignItems: "center",
                            background: "#fff",
                            color: "#363636",
                            lineHeight: "1.3",
                            willChange: "transform",
                            boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                            maxWidth: "350px",
                            pointerEvents: "auto",
                            padding: "14px 18px",
                            borderRadius: "8px",
                          }}
                          onClick={(e) => {

                            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                          }}
                        >
                          {errorMessage}
                        </div>
                      );
                      errors = true;
                    }
                  } else {
                    if (!/^[0-9]{3}$/.test(cvvValue)) {
                      errorMessage = "Please enter a valid CVV (3 digits)";

                      const targetElement = document.getElementById(element.selectedOption);
                      //console.log(targetElement);
                      toast.custom(
                        <div
                          style={{
                            fontSize: "17px",
                            display: "flex",
                            alignItems: "center",
                            background: "#fff",
                            color: "#363636",
                            lineHeight: "1.3",
                            willChange: "transform",
                            boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                            maxWidth: "350px",
                            pointerEvents: "auto",
                            padding: "14px 18px",
                            borderRadius: "8px",
                          }}
                          onClick={(e) => {

                            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                          }}
                        >
                          {errorMessage}
                        </div>
                      );
                      errors = true;

                    }

                  }


                  break;

                case "ssn":
                  if (!/^[0-9]{9}$/.test(value)) {
                    errorMessage =
                      "Please enter a valid ssn number (9 digits)";
                    errorMessages[element.selectedOption] = errorMessage;
                    setValidationErrors(errorMessages);
                    const targetElement = document.getElementById(element.selectedOption);
                    //console.log(targetElement);


                    toast.custom(
                      <div
                        style={{
                          fontSize: "17px",
                          display: "flex",
                          alignItems: "center",
                          background: "#fff",
                          color: "#363636",
                          lineHeight: "1.3",
                          willChange: "transform",
                          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                          maxWidth: "350px",
                          pointerEvents: "auto",
                          padding: "14px 18px",
                          borderRadius: "8px",
                        }}
                        onClick={(e) => {

                          targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }}
                      >
                        {errorMessage}
                      </div>
                    );
                    errors = true;
                    return;
                  }
                  break;

                default:
                  break;
              }
            }
          });
        });
        if (errors) {
          return;
        }
      }
    }
    const generateRandomNumber = () => {
      return Math.floor(Math.random() * 1000000); // Adjust the range as needed
    };
    setShowModal(true);
    let response;

    // var updateid1;
    if (accountData) {
      await updateAccountInSalesforce(id, accountData)
      logEvent('Data updated into salesforce');
    }
    if (terms) {
      formData.HQ_Paperwork_Status__c = "pdf-sent";
      logEvent('PDF-sent status updated to salesforce');
    } else {
      formData.HQ_Paperwork_Status__c = Number(largestFormId);

    }
    if (updateid || updateid1) {

      updateid1 = updateid;
      await updateRecordInSalesforce(updateid, formData, language);
      //toast.success("Record updated Successfully");
    } else {

      formData.Account__c = id;
      response = await postToInsuranceSalesforce(formData, language);
      console.log("not auto saving")
      if (response) {
        //toast.success("Record created successfully");
        setUpdatedId(response?.id);
        updateid1 = response?.id;
      }
    }


    /* if (terms && signatureData1) {
 
       //await uploadPDFs(e, updateid1, signatureData1);
       //await uploadPDF1s(updateid1, signatureData1);
     }*/
    if (a == 1) {

      setOk(1);

      await getRecordInfo2();
      setShowModal(false);
      setOkModal(true);
    } else {

      handleClear1();
      setTerms(false);
      // await getRecordInfo1();
      setFormData({});
      setShowModal(false);
      setOkModal(true);
      setOk(2);
      // setOkModal(true);
    }
    setAutoState(true);
    autostate1 = true
    return true;
  };

  const autosaving = async (formid, a) => {
    //console.log("autosaving function entered")
    console.log("value of  autostate", autostate)
    console.log("value of autostate1", autostate1)
    var signatureData1;

    if (!autostate || !autostate1) {
      return;
    }
    if (terms) {
      if (!signaturevalue) {
        if (!terms) {
          toast.error("Please accept terms");
          return;
        }
        if (signatureRef && signatureRef.isEmpty()) {
          toast.error("Please sign the form");
          setUploading(false);
          return;
        } else {
          const signatureData = signatureRef?.toDataURL();
          signatureData1 = signatureRef?.toDataURL();
          setSignatureValue(signatureData);
          //console.log(signatureData);
          localStorage.setItem("usersignature", JSON.stringify(signatureData));
          setSignatureRef(null);
        }
      }
      else {
        signatureData1 = signaturevalue
      }
    }
    console.log("value of 1", a)
    const largestFormId = Math.max(...changedFormIds);
    let errorMessages = {};
    let errors = false;
    console.log("value of 2", a)
    if (a == 1) {
      var completeforms = normalForms;
      console.log("autosaving normal forms")
    } else {
      var completeforms = consentForms;
    }
    const form = completeforms.find((f) => f.id == formid);
    console.log("forms entered", form);

    JSON.parse(form.formelements).forEach((element) => {
      if (formData.hasOwnProperty(element.selectedOption)) {
        let value = '';
        if (formData && formData[element.selectedOption]) {
          value = formData[element.selectedOption];
        } else if (accountData && accountData[element.selectedOption]) {
          value = accountData[element.selectedOption]
        }
        else if (formDataObject && formDataObject[element.selectedOption]) {
          value = formDataObject[element.selectedOption];
        } else if (accountDataObject && accountDataObject[element.selectedOption]) {
          value = accountDataObject[element.selectedOption];
        }

        let errorMessage = "";
        let errorMessage1 = "";
        if (element.isMandatory && (value === undefined || value === "")) {
          errorMessage1 = `Please Fill ${element.name}`;
          const targetElement = document.getElementById(element.selectedOption);

          toast.custom(
            <div
              style={{
                fontSize: "17px",
                display: "flex",
                alignItems: "center",
                background: "#fff",
                color: "#363636",
                lineHeight: "1.3",
                willChange: "transform",
                boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                maxWidth: "350px",
                pointerEvents: "auto",
                padding: "14px 18px",
                borderRadius: "8px",
              }}
              onClick={(e) => {

                targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }}
            >
              {errorMessage1}
            </div>
          );
          errors = true;
          return;
        } else if (value !== undefined && value !== "") {
          switch (element.validationType) {
            case "email":
              if (!/\S+@\S+\.\S+/.test(value)) {
                errorMessage = "Please enter a valid email";
                setValidationErrors(errorMessages);
                errors = true;
                // errorMessage1 = `Please Fill ${element.name}`;
                const targetElement = document.getElementById(element.selectedOption);
                toast.custom(
                  <div
                    style={{
                      fontSize: "17px",
                      display: "flex",
                      alignItems: "center",
                      background: "#fff",
                      color: "#363636",
                      lineHeight: "1.3",
                      willChange: "transform",
                      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                      maxWidth: "350px",
                      pointerEvents: "auto",
                      padding: "14px 18px",
                      borderRadius: "8px",
                    }}
                    onClick={(e) => {

                      targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }}
                  >
                    {errorMessage}
                  </div>
                );
                return;
              }
              break;


            case "number":
              if (element.selectedOption == 'HQ_Credit_Card_Number__c') {
                if (accountData['HQ_Credit_Card_Type__c']
                  ? accountData['HQ_Credit_Card_Type__c'] == 'American Express'
                  : accountDataObject['HQ_Credit_Card_Type__c'] ==
                  'American Express') {

                  if (!/^[0-9]{15}$/.test(value)) {
                    errorMessage =
                      "Please enter a valid number (15 digits)";


                    errors = true;
                    const targetElement = document.getElementById(element.selectedOption);
                    // console.log(targetElement);


                    toast.custom(
                      <div
                        style={{
                          fontSize: "17px",
                          display: "flex",
                          alignItems: "center",
                          background: "#fff",
                          color: "#363636",
                          lineHeight: "1.3",
                          willChange: "transform",
                          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                          maxWidth: "350px",
                          pointerEvents: "auto",
                          padding: "14px 18px",
                          borderRadius: "8px",
                        }}
                        onClick={(e) => {

                          targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }}
                      >
                        {errorMessage}
                      </div>
                    );



                  }
                } else {
                  if (!/^[0-9]{16}$/.test(value)) {
                    errorMessage =
                      "Please enter a valid  number (16 digits)";


                    errors = true;
                    const targetElement = document.getElementById(element.selectedOption);
                    // console.log(targetElement);


                    toast.custom(
                      <div
                        style={{
                          fontSize: "17px",
                          display: "flex",
                          alignItems: "center",
                          background: "#fff",
                          color: "#363636",
                          lineHeight: "1.3",
                          willChange: "transform",
                          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                          maxWidth: "350px",
                          pointerEvents: "auto",
                          padding: "14px 18px",
                          borderRadius: "8px",
                        }}
                        onClick={(e) => {

                          targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }}
                      >
                        {errorMessage}
                      </div>
                    );

                  }
                }

                //setValidationErrors(errorMessages);


              } else {
                if (isNaN(value)) {
                  errorMessage = "Please enter a valid number";
                  //setValidationErrors(errorMessages);
                  errors = true;
                  const targetElement = document.getElementById(element.selectedOption);
                  //console.log(targetElement);


                  toast.custom(
                    <div
                      style={{
                        fontSize: "17px",
                        display: "flex",
                        alignItems: "center",
                        background: "#fff",
                        color: "#363636",
                        lineHeight: "1.3",
                        willChange: "transform",
                        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                        maxWidth: "350px",
                        pointerEvents: "auto",
                        padding: "14px 18px",
                        borderRadius: "8px",
                      }}
                      onClick={(e) => {

                        targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      }}
                    >
                      {errorMessage}
                    </div>
                  );
                }
              }
              break;
            case "phone":
              if (!/^[0-9]{10}$/.test(value)) {
                errorMessage = "Please enter a valid phone number (10 digits)";
                errorMessages[element.selectedOption] = errorMessage;
                setValidationErrors(errorMessages);
                const targetElement = document.getElementById(element.selectedOption);
                toast.custom(
                  <div
                    style={{
                      fontSize: "17px",
                      display: "flex",
                      alignItems: "center",
                      background: "#fff",
                      color: "#363636",
                      lineHeight: "1.3",
                      willChange: "transform",
                      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                      maxWidth: "350px",
                      pointerEvents: "auto",
                      padding: "14px 18px",
                      borderRadius: "8px",
                    }}
                    onClick={(e) => {

                      targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }}
                  >
                    {errorMessage}
                  </div>
                );
                // toast.error(errorMessage);
                errors = true;
                return;
              }
              break;

            case "cvv":
              const cvvValue = value;
              if (accountData['HQ_Credit_Card_Type__c']
                ? accountData['HQ_Credit_Card_Type__c'] == 'American Express'
                : accountDataObject['HQ_Credit_Card_Type__c'] ==
                'American Express') {
                if (!/^[0-9]{4}$/.test(cvvValue)) {
                  errorMessage = "Please enter a valid CVV (4 digits)";
                  const targetElement = document.getElementById(element.selectedOption);
                  //console.log(targetElement);
                  errorMessages[element.selectedOption] = errorMessage;
                  setValidationErrors(errorMessages);
                  toast.custom(
                    <div
                      style={{
                        fontSize: "17px",
                        display: "flex",
                        alignItems: "center",
                        background: "#fff",
                        color: "#363636",
                        lineHeight: "1.3",
                        willChange: "transform",
                        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                        maxWidth: "350px",
                        pointerEvents: "auto",
                        padding: "14px 18px",
                        borderRadius: "8px",
                      }}
                      onClick={(e) => {

                        targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      }}
                    >
                      {errorMessage}
                    </div>
                  );
                  errors = true;
                }
              } else {
                if (!/^[0-9]{3}$/.test(cvvValue)) {
                  errorMessage = "Please enter a valid CVV (3 digits)";
                  const targetElement = document.getElementById(element.selectedOption);
                  toast.custom(
                    <div
                      style={{
                        fontSize: "17px",
                        display: "flex",
                        alignItems: "center",
                        background: "#fff",
                        color: "#363636",
                        lineHeight: "1.3",
                        willChange: "transform",
                        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                        maxWidth: "350px",
                        pointerEvents: "auto",
                        padding: "14px 18px",
                        borderRadius: "8px",
                      }}
                      onClick={(e) => {

                        targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      }}
                    >
                      {errorMessage}
                    </div>
                  );
                  errors = true;
                }
              }
              break;
            case "ssn":
              if (!/^[0-9]{9}$/.test(value)) {
                errorMessage =
                  "Please enter a valid ssn number (9 digits)";
                errorMessages[element.selectedOption] = errorMessage;
                setValidationErrors(errorMessages);
                const targetElement = document.getElementById(element.selectedOption);
                toast.custom(
                  <div
                    style={{
                      fontSize: "17px",
                      display: "flex",
                      alignItems: "center",
                      background: "#fff",
                      color: "#363636",
                      lineHeight: "1.3",
                      willChange: "transform",
                      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)",
                      maxWidth: "350px",
                      pointerEvents: "auto",
                      padding: "14px 18px",
                      borderRadius: "8px",
                    }}
                    onClick={(e) => {

                      targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }}
                  >
                    {errorMessage}
                  </div>
                );
                //toast.error(errorMessage);
                errors = true;
                return;
              }
              break;

            default:
              // Handle unknown validationType or no specific validation required
              break;
          }
        }
      }
    });
    if (errors) {
      return;
    }
    let response;
    if (accountData) {
      await updateAccountInSalesforce(id, accountData)
    }
    formData.HQ_Paperwork_Status__c = Number(largestFormId);

    if (updateid || updateid1) {
      if (updateid) {
        updateid1 = updateid;
      }
      await updateRecordInSalesforce(updateid1, formData, language);
      //toast.success("Record updated Successfully")
    } else {
      formData.Account__c = id;
      response = await postToInsuranceSalesforce(formData, language);
      console.log("auto saving")
      if (response) {
        updateid1 = response?.id;
        //toast.success("Record created successfully");
        setUpdatedId(response?.id);

      }
    }

  };


  const handleClear1 = () => {
    //e.preventDefault();
    //alert("hhhh");
    localStorage.removeItem("usersignature");
    setSignatureValue("");
    signatureRef?.clear();
    setSignatureValue1("");
    setSignatureRef(null);
    setSignatureRef1(null);
    logEvent('Signature Cleared1');
    //alert(formData.HQ_Patient_Name__c);
    //alert("uuuu")
  };


  const handleClear = (e) => {
    localStorage.removeItem("usersignature");
    e.preventDefault();
    //alert("jjjj");
    signatureRef?.clear();
    setSignatureValue("");
    setSignatureRef(null);
    setSignatureRef1(null);
    logEvent('Signature Cleared');
    // setSignatureRef1(null);
    //signatureRef.clear();
    //localStorage.removeItem("usersignature");
  };

  const ClearAll = async (e) => {
    e.preventDefault();
    formData.HQ_Paperwork_Status__c = "Clear";
    localStorage.removeItem("usersignature");
    setSignatureValue("");
    signatureRef?.clear();
    setSignatureValue1("");
    console.log(updateid)
    if (updateid) {
      await updateRecordInSalesforce(updateid, formData, language);
      //toast.success("Record Cleared Successfully");


    }

    setFormDataObject({});
    logEvent('Form Data Cleared');
    setContinueModal(false);
  }
  const handleNext = async () => {
    //setFormData({});
    setConsentFlag(true);
    setOkModal(false);
    logEvent('Transferring to form 2 - ok button clicked');
    window.scrollTo(0, 0);
  };

  const handleBack = () => {
    //setFormData({});
    setConsentFlag(false);
  };

  const generatePDFBase64 = async (htmlContent, name, a) => {

    var opt;
    if (a == 1) {
      opt = {
        margin: [10, 0, 18, 0],
        filename: `${name}.pdf`,
        image: { type: "jpeg", quality: 0.6 },
        html2canvas: { scale: 2, letterRendering: true, allowTaint: true, },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait", compress: true },
        pagebreak: { mode: ['css', 'legacy'], after: ".break" }
      };
    } else {
      opt = {
        margin: [0, 0, 15, 0],
        filename: `${name}.pdf`,
        image: { type: "jpeg", quality: 0.6 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: ["210", "820"], orientation: "portrait" },
        pagebreak: { mode: 'avoid-all' }
      };
    }

    //console.log(htmlContent)
    const pdfBlob = await html2pdf().from(htmlContent)
      .set(opt).outputPdf("blob");
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(pdfBlob);
      reader.onloadend = () => {
        const base64data = reader.result.split(",")[1];
        resolve(base64data);
      };
      reader.onerror = (error) => reject(error);
    });
  };
  const uploadPDFs1 = async (e, signaturevalue) => {
    e.preventDefault();
    // alert("hiii");
    consentForms.forEach(async (form, i) => {
      var content;
      var formvalue;
      if (form.formConditionalvalue) {
        //console.log(form);
        var parsedFormConditionalValue = JSON.parse(form?.formConditionalvalue);
        // console.log(parsedFormConditionalValue);
        formvalue = parsedFormConditionalValue?.value
        // console.log(formvalue);
      }
      if (!formDataObject[formvalue]) {
        content = generateHtmlForConsentForm(form, i, signaturevalue)

        {/* const newDiv = document.createElement('div');
      newDiv.innerHTML = content;
    document.body.appendChild(newDiv); */}
        // Get the i-th content area
        // console.log(content); // Skip if the element does not exist
        if (!content) {
          // console.log(`No content found for .pdf-content${i}`);
          return; // Skip the rest of this iteration
        }


        const base64PDF = await generatePDFBase64(content, form.name, 2);
      }
    })
    /* var content = await generateHtmlForForm(signaturevalue);
     // Get the i-th content area
     console.log(content); // Skip if the element does not exist
     if (!content) {
       console.log(`No content found for pdf wrapper print`);
       return; // Skip the rest of this iteration
     }
    
   var today = new Date();
 var dd = String(today.getDate()).padStart(2, '0');
 var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
 var yyyy = today.getFullYear();
 
 today = mm + '/' + dd + '/' + yyyy;
   var pdfName = 'HEALTH QUESTIONARRIE'+ today;
     const base64PDF =  await generatePDFBase64(content, "Nonconsentforms", 1);*/
    //const base64PDF = await generatePDFBase64(content, "Nonconsentforms", 1);*/
  }

  const generateAndUploadInitialPDF = async (e, id, signatureData1) => {
    e.preventDefault();
    var content = await generateHtmlForForm(signatureData1);
    if (!content) {
      console.log(`No content found for pdf wrapper print`);
      return; // Skip the rest of this iteration
    }
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy;
    var pdfName = 'HEALTH QUESTIONARRIE' + today;
    const base64PDF = await generatePDFBase64(content, "Nonconsentforms", 1);
    console.log(base64PDF)
    await sendToSalesforce(base64PDF, pdfName, id);
  };

  const generateAndUploadSecondPDF = async (e, id, signatureData1) => {
    e.preventDefault();
    var content = await generateHtmlForForm1(signatureData1);
    if (!content) {
      console.log(`No content found for pdf wrapper print`);
      return; // Skip the rest of this iteration
    }
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy;
    var pdfName = 'HEALTH QUESTIONARRIE' + today;
    const base64PDF = await generatePDFBase64(content, "Nonconsentforms", 1);
    await sendToSalesforce(base64PDF, pdfName, id);
  };


  const uploadPDFs = async (e, id, signatureData1) => {

    //setUploading(true);
    e.preventDefault();
    try {

      const nonconsentpromises = [
        generateAndUploadInitialPDF(e, id, signatureData1),
        generateAndUploadSecondPDF(e, id, signatureData1)
      ];
      Promise.all(nonconsentpromises)
        .then(() => {

          console.log("All PDFs uploaded successfully.");

          const promises = consentForms.map(async (form, i) => {

            var content;
            var formvalue;
            if (form.formConditionalvalue) {
              // console.log(form);
              var parsedFormConditionalValue = JSON.parse(form?.formConditionalvalue);
              // console.log(parsedFormConditionalValue);
              formvalue = parsedFormConditionalValue?.value
              // console.log(formvalue);
            }
            if (!formDataObject[formvalue]) {

              content = await generateHtmlForConsentForm(form, i, signatureData1)

              {/* const newDiv = document.createElement('div');
          newDiv.innerHTML = content;
        document.body.appendChild(newDiv); */}
              // Get the i-th content area
              // console.log(content); // Skip if the element does not exist
              if (!content) {
                // console.log(`No content found for .pdf-content${i}`);
                return; // Skip the rest of this iteration
              }


              const base64PDF = await generatePDFBase64(content, form.name, 2);
              await sendToSalesforce(base64PDF, form.name, id);
              console.log(`PDF ${i + 1} uploaded successfully.`);


            }
            /*if (i == consentForms.length - 1) {
            
                          setTimeout(myredirect, 30000);
                        }*/


          });

          // Wait for all promises to resolve
          Promise.all(promises)
            .then(() => {

              //console.log("All PDFs uploaded successfully.");
              handleClear1();
              setTerms(false);
              // await getRecordInfo1();
              setFormData({});
              setShowModal(false);
              setOkModal(true);
              setOk(2);


            })
            .catch((error) => {
              logEvent("Signature is not cleared");
              console.error("Error uploading PDFs:", error);
            });
        })
        .catch((error) => {
          logEvent("PDF Connection Issue");
          console.error("Error uploading PDFs:", error);
        });
    } catch (error) {
      console.error("An error occurred during the PDF upload process:", error);
      logEvent('PDF upload process issue - You generally shouldnt be seeing this');
    } finally {

      //toast.success("Record Submitted Successfully");
      //setUploading(false);
    }

  };
  const uploadPDF1s = async (id, signatureData1) => {
    //setUploading(true);

    try {
      var content = await generateHtmlForForm1(signatureData1);
      // Get the i-th content area
      // console.log(content); // Skip if the element does not exist
      if (!content) {
        console.log(`No content found for pdf wrapper print`);
        return; // Skip the rest of this iteration
      }
      /* const newDiv = document.createElement('div');
     newDiv.innerHTML = content;
    document.body.appendChild(newDiv); */
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      today = mm + '/' + dd + '/' + yyyy;
      var pdfName = 'HEALTH QUESTIONARRIE1' + today;
      const base64PDF = await generatePDFBase64(content, "Nonconsentforms", 1);
      await sendToSalesforce(base64PDF, pdfName, id);



      //handleBack();
      // logout1();
      //console.log('All PDFs have been uploaded successfully.');
    } catch (error) {
      console.error("An error occurred during the PDF upload process:", error);
    } finally {

      //toast.success("Record Submitted Successfully");
      //setUploading(false);
    }

  };
  { /*console.log(inputRefs)*/ }

  const myredirect = async () => {
    await setOkModal(true);
    setOk(2);
    setShowModal(false);
  }

  const generateHtmlForConsentForm = (form, i, signatureData1) => {

    let formHtml = `<div className="break1">`;
    // Use forEach loop instead of forEach async for synchronous operations

    formHtml += `<div style="margin:auto; text-align:center; display:flex; justify-content:center">
        <img src="${logo}" alt="Logo" style="width:60%; margin:auto; padding:20px 0"/>
      </div>
      <div class="contentWrap" style=" border: 1px solid #ccc;">
        <h3 style="color:red;font-weight: bold;font-size: 30px;text-align:center">${form.name}</h3>
        <div  style="padding: 10px;">`;
    JSON.parse(form.formelements).forEach((element, index) => {
      var elementHtml = '';

      if (element.elementType === "PatientName") {
        elementHtml = `
        <div className="question">Patient Name</div>
        <div>${userData?.Name}</div>`;
      }
      else if (element.elementType == "Email") {
        elementHtml = `
    
        <div className="question">Email</div>
                          <div>${userData?.PersonEmail}</div>`;
      }
      else if (element.elementType == "PatientName And Date") {
        const currentDate = new Date().toLocaleDateString();
        elementHtml = `<div class="patientNameDate">
        <div className="question">Patient Name and Date</div>
                            <div class="floatLeft">${userData?.Name}</div>
                            <div class="floatRight">${currentDate}</div>
                            </div>
                          </div>`;
      }

      else if (element.elementType == "PhoneNumber") {
        elementHtml = `<div className="question">Cell Phone Number</div>
                          <div>${userData?.Phone}</div>`;
      }

      else if (element.elementType == "DateOfBirth") {

        elementHtml = `<div className="question">Date Of Birth</div>
        
        <div>${userData?.Date_of_Birth__c}</div>`;
      }


      else if (element.elementType === "ConsentTextarea" && element.content) {
        var data = element.content.replace(
          /\$(Name|InsuranceCompany)/g,
          (match, p1) =>
            p1 === "Name"
              ? userData?.Name || ""
              : formData["HQ_Insurance_Carrier_Name__c"]
                ? formData["HQ_Insurance_Carrier_Name__c"]
                : formDataObject["HQ_Insurance_Carrier_Name__c"] || ""
        );
        elementHtml = `<div className="1234">${data}</div>`;
      } else {
        let value;
        if (formData && formData[element.selectedOption]) {
          value = formData[element.selectedOption];
        } else if (accountData && accountData[element.selectedOption]) {
          value = accountData[element.selectedOption];
        } else if (formDataObject && formDataObject[element.selectedOption]) {
          value = formDataObject[element.selectedOption];
        } else if (accountDataObject && accountDataObject[element.selectedOption]) {
          value = accountDataObject[element.selectedOption];
        }

        elementHtml += `<div class="form-element ${element.elementType === "Text Field" ? "fiftyByFifty" : ""}" style="margin-bottom: 15px;">`;
        if (element.name) {
          elementHtml += `<label style="font-weight: bold; font-size:15px">${element.name}</label>`;
        }
        if (value !== '' && value !== undefined) {
          elementHtml += `<div style="margin-bottom: 5px; padding:0; font-size:15px">${value}</div>`;
        }
        elementHtml += `</div>`;
      }

      if (element.conditional) {
        element.conditional.forEach((condition) => {
          const conditionValue = formData[condition.selectedOption] || formDataObject[condition.selectedOption] || "";
          elementHtml += `<div style="margin-top: 10px;">
                <label style="font-weight: bold; font-size:18px">${condition.name}</label>
                <div style="font-size:15px">${conditionValue}</div>
              </div>`;
        });
      }

      formHtml += elementHtml;
    });


    if (signatureData1) {
      formHtml += `<div style="margin-top: 20px;">
          <img src="${signatureData1}" alt="User Signature" style="max-width: 200px;"/>
        </div>`;
    }

    formHtml += `</div></div>`;

    formHtml += `</div>`;

    formHtml += ` <div>
                    <input
                        type="checkbox"
                        checked="true"
                    />
                    <label>By checking the box I acknowledge and agree that I have read the terms of the above section and agree to insert my electronic signature as set forth below indicating my consent to this page. </label>
                    </div>`;

    return formHtml;
  };

  const generateHtmlForForm = (signatureData1) => {

    let formHtml = `<div className='pdfwrapperprint'>`;
    normalForms.forEach(async (form, i) => {
      //console.log("3")
      if (i >= 0 && i <= 1) {
        const isMotorVehicleAccident = (
          formData['HQ_Motor_Vehiclle_Accident_Relevance__c'] ? formData['HQ_Motor_Vehiclle_Accident_Relevance__c'] == 'Motor vehicle accident' :
            formDataObject['HQ_Motor_Vehiclle_Accident_Relevance__c'] == 'Motor vehicle accident' || ""
        );

        const isExcludedForm = ['Irrevocable Practice Lien-patient Financial Agreement', 'Assignment Of Benefits Form'].includes(form.name);


        if (!isExcludedForm || isMotorVehicleAccident) {
          formHtml += `<div class="break">`;



          formHtml += `<div  style="margin:auto;padding-top:20px; padding-bottom:20px; text-align:center; display:flex; justify-content:center">
    <img src=${logo} alt="Logo" style="width:60%; margin:auto; padding:20px 0"/>
  </div>
    <div class="contentWrap" style="padding: 20px; border: 1px solid #ccc; margin-bottom: 10px;">
                      <h3 style="color:red;font-weight: bold;font-size: 30px;text-align:center">${form.name}</h3>
                      <div class="" style="padding: 10px;">`;
          JSON.parse(form.formelements).forEach((element, index) => {
            let value = '';

            if (formData && formData[element.selectedOption]) {
              value = formData[element.selectedOption];
            } else if (accountData && accountData[element.selectedOption]) {
              value = accountData[element.selectedOption];
            } else if (formDataObject && formDataObject[element.selectedOption]) {
              value = formDataObject[element.selectedOption];
            } else if (accountDataObject && accountDataObject[element.selectedOption]) {
              value = accountDataObject[element.selectedOption];
            }

            let elementHtml = '';

            if (element.elementType === "ConsentTextarea" && element.content) {
              let data = element.content.replace(
                /\$(Name|InsuranceCompany)/g,
                (match, p1) =>
                  p1 === "Name"
                    ? userData?.Name || ""
                    : formData["HQ_Insurance_Carrier_Name__c"]
                      ? formData["HQ_Insurance_Carrier_Name__c"]
                      : formDataObject["HQ_Insurance_Carrier_Name__c"] || ""
              );
              elementHtml = `<div className="1234">${data}</div>`;
            } else if (element.elementType == "Email") {
              elementHtml = `
      
          <div style="font-weight:bold;">Email</div>
                            <div>${userData?.PersonEmail}</div>`;
            }
            else if (element.elementType == "PatientName And Date") {
              const currentDate = new Date().toLocaleDateString();
              elementHtml = `<div class="patientNameDate">
          <div  style="font-weight:bold;">Patient Name And Date</div>
                              <div class="floatLeft">${userData?.Name}</div>
                              <div class="floatRight">${currentDate}</div>
                              </div>
                            </div>`;
            }

            else if (element.elementType == "PhoneNumber") {
              elementHtml = `<div  style="font-weight:bold;">Cell Phone Number</div>
                            <div>${userData?.Phone}</div>`;
            }
            else if (element.elementType == "PatientName") {
              elementHtml = `
          <div  style="font-weight:bold;">Patient Name</div>
          <div>${userData?.Name}</div>`;
            }

            else if (element.elementType == "DateOfBirth") {

              elementHtml = `<div  style="font-weight:bold;">Date Of Birth</div>
          
          <div>${userData?.Date_of_Birth__c}</div>`;
            }
            else if (element.elementType == 'Height Field') {
              let value1 = '';
              if (element.selectedOption2) {
                if (formData && formData[element.selectedOption2]) {
                  value1 = formData[element.selectedOption2];
                } else if (accountData && accountData[element.selectedOption2]) {
                  value1 = accountData[element.selectedOption2];
                }
              }
              elementHtml = `<div class="form-element ${element.elementType === "Text Field" ? "fiftyByFifty" : ""}"  style="margin-bottom: 15px;">
                            <label style="font-weight: bold; font-size:18px">${element.name}</label>                    
                            <div style="margin:0 0 5px 0; padding:0;  font-size:18px">Feet: ${value}</div>
                            <div style="margin:0 0 5px 0; padding:0;  font-size:18px">Inches: ${value1}</div>
                          </div>`;
            } else {
              elementHtml = `<div class="form-element ${element.elementType === "Text Field" ? "fiftyByFifty" : ""}"  style="margin-bottom: 15px;">
                            <label style="font-weight: bold; font-size:18px">${element.name}</label>                    
                            <div style="margin:0 0 5px 0; padding:0;  font-size:18px">${value}</div>
                          </div>`;
            }

            if (element.conditional) {
              element.conditional.forEach((condition) => {
                const conditionValue = formData[condition.selectedOption] || formDataObject[condition.selectedOption] || "";
                if (conditionValue) {
                  elementHtml += `<div style="margin-top: 10px;">
                                <label style="font-weight: bold; font-size:18px">${condition.name}</label>
                                <div style="font-size:15px">${conditionValue}</div>
                              </div>`;
                }
              });
            }

            formHtml += elementHtml;
          });




          formHtml += `</div></div>`;


          formHtml += `</div>`;


          if (i > 0) {
            formHtml += ` <div className="html2pdf__page-break"></div>`;
          }
        }
      }
    });

    if (signatureData1) {
      formHtml += `<div style="margin-top: 20px;">
                   <img src="${signatureData1}" alt="User Signature" style="max-width: 200px;"/>
                    </div>`;
    }
    formHtml += `</div>`;
    return formHtml;
  };
  {/*console.log(normalForms)*/ }
  const generateHtmlForForm1 = (signatureData1) => {

    let formHtml = `<div className='pdfwrapperprint'>`;
    normalForms.forEach(async (form, i) => {
      if (i >= 2 && i <= 3) {
        // console.log(2)
        const isMotorVehicleAccident = (
          formData['HQ_Motor_Vehiclle_Accident_Relevance__c'] ? formData['HQ_Motor_Vehiclle_Accident_Relevance__c'] == 'Motor vehicle accident' :
            formDataObject['HQ_Motor_Vehiclle_Accident_Relevance__c'] == 'Motor vehicle accident' || ""
        );

        const isExcludedForm = ['Irrevocable Practice Lien-patient Financial Agreement', 'Assignment Of Benefits Form'].includes(form.name);


        if (!isExcludedForm || isMotorVehicleAccident) {
          formHtml += `<div class="break">`;



          formHtml += `<div  style="margin:auto;padding-top:20px; padding-bottom:20px; text-align:center; display:flex; justify-content:center">
    <img src=${logo} alt="Logo" style="width:60%; margin:auto; padding:20px 0"/>
  </div>
    <div class="contentWrap" style="padding: 20px; border: 1px solid #ccc; margin-bottom: 10px;">
                      <h3 style="color:red;font-weight: bold;font-size: 30px;text-align:center">${form.name}</h3>
                      <div class="" style="padding: 10px;">`;
          JSON.parse(form.formelements).forEach((element, index) => {
            let value = '';

            if (formData && formData[element.selectedOption]) {
              value = formData[element.selectedOption];
            } else if (accountData && accountData[element.selectedOption]) {
              value = accountData[element.selectedOption];
            } else if (formDataObject && formDataObject[element.selectedOption]) {
              value = formDataObject[element.selectedOption];
            } else if (accountDataObject && accountDataObject[element.selectedOption]) {
              value = accountDataObject[element.selectedOption];
            }

            let elementHtml = '';

            if (element.elementType === "ConsentTextarea" && element.content) {
              let data = element.content.replace(
                /\$(Name|InsuranceCompany)/g,
                (match, p1) =>
                  p1 === "Name"
                    ? userData?.Name || ""
                    : formData["HQ_Insurance_Carrier_Name__c"]
                      ? formData["HQ_Insurance_Carrier_Name__c"]
                      : formDataObject["HQ_Insurance_Carrier_Name__c"] || ""
              );
              elementHtml = `<div className="1234">${data}</div>`;
            } else if (element.elementType == "Email") {
              elementHtml = `
      
          <div style="font-weight:bold;">Email</div>
                            <div>${userData?.PersonEmail}</div>`;
            }
            else if (element.elementType == "PatientName And Date") {
              const currentDate = new Date().toLocaleDateString();
              elementHtml = `<div class="patientNameDate">
          <div  style="font-weight:bold;">Patient Name And Date</div>
                              <div class="floatLeft">${userData?.Name}</div>
                              <div class="floatRight">${currentDate}</div>
                              </div>
                            </div>`;
            }

            else if (element.elementType == "PhoneNumber") {
              elementHtml = `<div  style="font-weight:bold;">Cell Phone Number</div>
                            <div>${userData?.Phone}</div>`;
            }
            else if (element.elementType == "PatientName") {
              elementHtml = `
          <div  style="font-weight:bold;">Patient Name</div>
          <div>${userData?.Name}</div>`;
            }

            else if (element.elementType == "DateOfBirth") {

              elementHtml = `<div  style="font-weight:bold;">Date Of Birth</div>
          
          <div>${userData?.Date_of_Birth__c}</div>`;
            }
            else if (element.elementType == 'Height Field') {
              let value1 = '';
              if (element.selectedOption2) {
                if (formData && formData[element.selectedOption2]) {
                  value1 = formData[element.selectedOption2];
                } else if (accountData && accountData[element.selectedOption2]) {
                  value1 = accountData[element.selectedOption2];
                }
              }
              elementHtml = `<div class="form-element ${element.elementType === "Text Field" ? "fiftyByFifty" : ""}"  style="margin-bottom: 15px;">
                            <label style="font-weight: bold; font-size:18px">${element.name}</label>                    
                            <div style="margin:0 0 5px 0; padding:0;  font-size:18px">Feet: ${value}</div>
                            <div style="margin:0 0 5px 0; padding:0;  font-size:18px">Inches: ${value1}</div>
                          </div>`;
            } else {
              elementHtml = `<div class="form-element ${element.elementType === "Text Field" ? "fiftyByFifty" : ""}"  style="margin-bottom: 15px;">
                            <label style="font-weight: bold; font-size:18px">${element.name}</label>                    
                            <div style="margin:0 0 5px 0; padding:0;  font-size:18px">${value}</div>
                          </div>`;
            }

            if (element.conditional) {
              element.conditional.forEach((condition) => {
                const conditionValue = formData[condition.selectedOption] || formDataObject[condition.selectedOption] || "";
                if (conditionValue) {
                  elementHtml += `<div style="margin-top: 10px;">
                                <label style="font-weight: bold; font-size:18px">${condition.name}</label>
                                <div style="font-size:15px">${conditionValue}</div>
                              </div>`;
                }
              });
            }

            formHtml += elementHtml;
          });




          formHtml += `</div></div>`;


          formHtml += `</div>`;


          if (i > 0) {
            formHtml += ` <div className="html2pdf__page-break"></div>`;
          }
        }
      }
    });

    if (signatureData1) {
      formHtml += `<div style="margin-top: 20px;">
                   <img src="${signatureData1}" alt="User Signature" style="max-width: 200px;"/>
                    </div>`;
    }
    formHtml += `</div>`;
    return formHtml;
  };
  { /*console.log(accountData)*/ }


  const renderConditionals = (
    conditionElement,
    formIndex,
    form,
    formData,
    formDataObject,
    validationErrors,
    handleChange
  ) => {
    console.log(conditionElement);
    
    return conditionElement?.conditional?.map((condition, index) => {
      const selectedOption =
        formData[conditionElement.selectedOption] ||
        formDataObject[conditionElement.selectedOption];
  
      // Check if the selected option matches the current conditional
      if (selectedOption === condition.selectedConditionalOption) {
        // Common render properties
        const errorMessage = validationErrors[condition.selectedOption];
  
        const renderInput = (inputType, additionalProps = {}) => (
          <input
            id={condition.selectedOption}
            type={inputType}
            readOnly={condition.isReadOnly}
            name={condition.selectedOption}
            value={formData[condition.selectedOption] || formDataObject[condition.selectedOption] || ""}
            onChange={(e) => handleChange(e, condition, formIndex, form?.id, 1)}
            {...additionalProps}
          />
        );
  
        // Check element types and render accordingly
        switch (condition.elementType) {
          case "ConsentTextarea": {
            let data = condition.content.replace(/\$(Name|InsuranceCompany)/g, (match, p1) =>
              p1 === "Name"
                ? userData?.Name || ""
                : formData["HQ_Insurance_Carrier_Name__c"] || formDataObject["HQ_Insurance_Carrier_Name__c"] || ""
            );
            data = data.replace(/\$Input/g, '<input type="text" />');
            return <div key={index} dangerouslySetInnerHTML={{ __html: data }} />;
          }
  
          case "Text Field":
          case "Textarea": {
            return (
              <div className="conditionalWrap" key={index}>
                <label className="question">{condition?.name}</label>
                {condition.isMandatory && !formData[condition.selectedOption] && !formDataObject[condition.selectedOption] && (
                  <div className="error-message">*</div>
                )}
                {renderInput(condition.elementType === "Text Field" ? "text" : "textarea")}
                {errorMessage && <div className="error-message">{errorMessage}</div>}
              </div>
            );
          }
  
          case "Date Picker": {
            return (
              <div className="conditionalWrap" key={index}>
                <label className="question">{condition?.name}</label>
                {condition.isMandatory && !formData[condition.selectedOption] && !formDataObject[condition.selectedOption] && (
                  <span className="error-message">*</span>
                )}
                {renderInput("date", { min: minDateString, max: maxDate })}
                {errorMessage && <div className="error-message">{errorMessage}</div>}
              </div>
            );
          }
  
          case "Dropdown": {
            return (
              <div className="dropdownStyle conditionalWrap" key={index}>
                <label className="question">{condition?.name}</label>
                {condition.isMandatory && !formData[condition.selectedOption] && !formDataObject[condition.selectedOption] && (
                  <span className="error-message">*</span>
                )}
                <select
                  id={condition.selectedOption}
                  name={condition.selectedOption}
                  value={formData[condition.selectedOption] || formDataObject[condition.selectedOption] || ""}
                  onChange={(e) => handleChange(e, condition, formIndex, form?.id, 1)}
                >
                  <option value="">{`Please Select`}</option>
                  {condition.options.map((option, optionIndex) => (
                    <option key={optionIndex} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                {errorMessage && <div className="error-message">{errorMessage}</div>}
              </div>
            );
          }
  
          case "Checkbox": {
            return (
              <div className="conditionalWrap" key={index}>
                <label className="question">{condition?.name}</label>
                {condition?.options.map((option, optionIndex) => (
                  <div key={optionIndex} className="optionEntry">
                    <input
                      id={condition.selectedOption}
                      type="checkbox"
                      name={condition.selectedOption}
                      value={option}
                      onChange={(e) => handleChange(e, condition, formIndex, form?.id, 1)}
                      checked={formData[condition.selectedOption] ? formData[condition.selectedOption] === option : formDataObject[condition.selectedOption] === option}
                    />
                    <label className="question">{option}</label>
                  </div>
                ))}
                {condition.isMandatory && !formData[condition.selectedOption] && !formDataObject[condition.selectedOption] && (
                  <div className="error-message">*{condition?.name} Mandatory</div>
                )}
                {errorMessage && <div className="error-message">{errorMessage}</div>}
                {condition?.conditional?.length > 0 && renderConditionals(condition, formIndex, form, formData, formDataObject, validationErrors, handleChange)}
              </div>
            );
          }
  
          default:
            return null; // Handle unexpected element types
        }
      }
      return null; // Return null if the selected option does not match
    });
  };
  
  const renderForm = (form, formIndex) => (

    <>
      <div className="contentWrap">
        <h3>{language == 1 ? form?.name : form.name_es}</h3>
        <div key={form?.id} class="form-container">
          <form>
            <div className={`pdf-content`}>
              {JSON.parse(language == 1 ? form.formelements : form.formelements_es).map((element, index) => (
                <div
                  key={index}
                  className={`form-element ${element.elementType === "Text Field" ? "fiftyByFifty" : ""} ${element.elementType === "PatientName" ? "fiftyByFifty" : ""}  ${element.elementType === 'Dropdown' ? 'fiftyByFifty' : ''} ${element.elementType === 'Height Field' ? 'fiftyByFifty' : ''}`}>
                  <>

                    {element.elementType == "Signature" && (
                      <>
                        <div className="question">{element.name}</div>
                        <div style={{ width: '400px', height: '200px', border: '1px solid black' }}></div>
                      </>
                    )}


                    {element.elementType == "cctype" && (
                      <>
                        <div className="dropdownStyle">

                          <div>
                            <label className="question">{element?.name}</label>
                            {element.isMandatory &&
                              !accountData[element.selectedOption] &&
                              !accountDataObject[element.selectedOption] && (
                                <span className="error-message">
                                  *
                                </span>
                              )}
                          </div>

                          <select
                            id={element.selectedOption}
                            name={element.selectedOption}
                            value={accountData[element.selectedOption] ||
                              accountDataObject[element.selectedOption] || ""


                            }
                            onChange={(e) =>
                              handleChange(e, element, 'p', form?.id, 1)
                            }
                          >
                            <option value="">{`Please Select`}</option>
                            {element.options.map((option, optionIndex) => (
                              <option key={optionIndex} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                          {validationErrors[element.selectedOption] && (
                            <div className="error-message">
                              {validationErrors[element.selectedOption]}
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    {element.elementType == "ccdatepicker" && (
                      <div>
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !accountData[element.selectedOption] &&
                            !accountDataObject[element.selectedOption] && (
                              <span className="error-message">*</span>
                            )}
                        </div>
                        <input
                          id={element.selectedOption}
                          type="month"
                          min={minDateString}
                          name={element.selectedOption}
                          readOnly={element.isReadOnly}
                          value={
                            accountData[element.selectedOption]
                              ? accountData[element.selectedOption]
                              : accountDataObject[element.selectedOption]
                          }
                          onChange={(e) =>
                            handleChange(e, element, 'p', form.id, 1)
                          }
                        />


                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>

                    )}

                    {element.elementType === "MultiSelectCheckbox" && (
                      <div>
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !formData[element.selectedOption] &&
                            !formDataObject[element.selectedOption] && (
                              <span className="error-message">
                                *
                              </span>
                            )}
                        </div>
                        <MultiSelect

                          element={element}
                          formDataObject={formDataObject}
                          setFormData={setFormData}
                          setChangedFormIds={setChangedFormIds}
                          setNormalFormIds={setNormalFormIds}
                          form={form}
                          formData={formData}
                          validationErrors={validationErrors}
                        />
                      </div>
                    )}
                    {element.elementType == "Address" && (
                      <div>
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !formData[element.selectedOption] &&
                            !formDataObject[element.selectedOption] && (
                              <span className="error-message">*</span>
                            )}
                        </div>
                        {/*                         <input
                          id={element.selectedOption}
                          type="text"
                          name={element.selectedOption}
                          readOnly={element.isReadOnly}
                          value={
                            formData[element.selectedOption]
                              ? formData[element.selectedOption]
                              : formDataObject[element.selectedOption] || ""
                          }
                          onChange={(e) =>
                            handleChange(e, element, formIndex, form?.id, 1)
                          }
                        /> */}
                        <GooglePlacesAutocomplete
                          apiKey="AIzaSyBBKKQMuAlA8rlwlDBSyWyRvgz0chj5blM"
                          onPlaceSelected={(place) => {
                            if (place && place.formatted_address) {
                              setFormData((prevFormData) => ({
                                ...prevFormData,
                                [element.selectedOption]: place.formatted_address,
                              }));
                              //  alert(place.formatted_address);
                            }
                          }}
                          options={{
                            types: ['address'], // Specify the types of places to be restricted (optional)
                            componentRestrictions: { country: 'us' }, // Restrict the search to a specific country (optional)
                          }}
                          style={{ width: '100%' }}
                        />
                      </div>
                    )}

                    {element.elementType === "ConsentTextarea" && element?.content && (
                      (() => {
                        // Compute the data variable
                        var data = element.content.replace(
                          /\$(Name|InsuranceCompany)/g,
                          (match, p1) =>
                            p1 === "Name"
                              ? userData?.Name || ""
                              : formData["HQ_Insurance_Carrier_Name__c"]
                                ? formData["HQ_Insurance_Carrier_Name__c"]
                                : formDataObject["HQ_Insurance_Carrier_Name__c"] || ""
                        );
                        data = data.replace(/\$Input/g, '<input type="text" />');

                        // Return JSX with the computed data
                        return (
                          <div
                            dangerouslySetInnerHTML={{ __html: data }}
                          />
                        );
                      })()
                    )}

                    {/* Other input types */}
                    {element.elementType == "Text Field" && (
                      <div>
                        <div className="spacing5">
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !formData[element.selectedOption] &&
                            !formDataObject[element.selectedOption] && (
                              <span className="error-message">
                                *
                              </span>
                            )}
                        </div>
                        <input
                          id={element.selectedOption}
                          readOnly={element.isReadOnly}
                          type={element.validationType == 'phone' || element.validationType == 'number' ? 'number' : "text"}
                          name={element.selectedOption}
                          style={{
                            WebkitAppearance: 'none',

                          }}
                          value={
                            formData[element.selectedOption]
                              ? formData[element.selectedOption]
                              : formDataObject[element.selectedOption] || ""
                          }
                          onChange={(e) => {
                            let errorMessages = {};
                            let errorMessage = '';

                            switch (element.validationType) {
                              case "email":
                                if (!/\S+@\S+\.\S+/.test(e.target.value)) {

                                  errorMessage = "Please enter a valid email";


                                }
                                break;
                              case "number":
                                if (isNaN(e.target.value)) {
                                  errorMessage = "Please enter a valid number";

                                }
                                break;
                              case "phone":
                                if (!/^[0-9]{10}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid phone number (10 digits)";
                                }
                                break;
                              case "cvv":
                                const cvvValue = e.target.value;
                                if (!/^[0-9]{3,4}$/.test(cvvValue)) {
                                  errorMessage = "Please enter a valid CVV (3 or 4 digits)";
                                  errorMessages[element.selectedOption] = errorMessage;
                                  setValidationErrors(errorMessages);
                                } else {
                                  // Clear any existing error message if input is valid
                                  delete errorMessages[element.selectedOption];
                                  setValidationErrors(errorMessages);
                                }
                                break;
                              case "ssn":
                                if (!/^[0-9]{9}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid ssn number (9 digits)";
                                }
                                break;
                              default:
                                // Handle unknown validationType or no specific validation required
                                break;
                            }
                            errorMessages[element.selectedOption] = errorMessage;
                            setValidationErrors(errorMessages);
                            handleChange(e, element, formIndex, form?.id, 1)
                          }}
                        />
                        {element.validationType === "phone" && (
                          <div style={{ fontSize: '1rem', marginTop: '0.5rem', color: 'black' }}>
                            Please enter the phone nsumber without any special characters (/, -) or country code, like this example: 7320891234
                          </div>
                        )}
                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>
                    )}
                    {element.elementType == "Payment" && (
                      <div>
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !accountData[element.selectedOption] &&
                            !accountDataObject[element.selectedOption] && (
                              <span className="error-message">
                                *
                              </span>
                            )}
                        </div>

                        <input
                          id={element.selectedOption}
                          type={element.validationType == 'cvv' || element.validationType == 'number' ? 'number' : "text"}
                          readOnly={element.isReadOnly}
                          name={element.selectedOption}
                          value={(accountData && accountData[element.selectedOption]) || (accountDataObject && accountDataObject[element.selectedOption]) || ''}
                          onChange={(e) => {
                            let errorMessages = {};
                            let errorMessage = '';

                            switch (element.validationType) {
                              case "email":
                                if (!/\S+@\S+\.\S+/.test(e.target.value)) {

                                  errorMessage = "Please enter a valid email";


                                }
                                break;
                              case "number":
                                if (element.selectedOption == 'HQ_Credit_Card_Number__c') {
                                  if (accountData['HQ_Credit_Card_Type__c']
                                    ? accountData['HQ_Credit_Card_Type__c'] == 'American Express'
                                    : accountDataObject['HQ_Credit_Card_Type__c'] ==
                                    'American Express') {

                                    if (!/^[0-9]{15}$/.test(e.target.value)) {
                                      errorMessage =
                                        "Please enter a valid number (15 digits)";


                                    }
                                  } else {
                                    if (!/^[0-9]{16}$/.test(e.target.value)) {
                                      errorMessage =
                                        "Please enter a valid  number (16 digits)";


                                    }
                                  }

                                } else {
                                  if (isNaN(e.target.value)) {
                                    errorMessage = "Please enter a valid number";

                                  }
                                }

                                break;
                              case "phone":
                                if (!/^[0-9]{10}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid phone number (10 digits)";


                                }
                                break;

                              case "cvv":
                                const cvvValue = e.target.value;
                                if (accountData['HQ_Credit_Card_Type__c']
                                  ? accountData['HQ_Credit_Card_Type__c'] == 'American Express'
                                  : accountDataObject['HQ_Credit_Card_Type__c'] ==
                                  'American Express') {
                                  if (!/^[0-9]{4}$/.test(cvvValue)) {
                                    errorMessage = "Please enter a valid CVV (4 digits)";
                                    errorMessages[element.selectedOption] = errorMessage;
                                    setValidationErrors(errorMessages);
                                  } else {
                                    // Clear any existing error message if input is valid
                                    delete errorMessages[element.selectedOption];
                                    setValidationErrors(errorMessages);
                                  }
                                } else {
                                  if (!/^[0-9]{3}$/.test(cvvValue)) {
                                    errorMessage = "Please enter a valid CVV (3 digits)";
                                    errorMessages[element.selectedOption] = errorMessage;
                                    setValidationErrors(errorMessages);
                                  } else {
                                    // Clear any existing error message if input is valid
                                    delete errorMessages[element.selectedOption];
                                    setValidationErrors(errorMessages);
                                  }
                                }
                                break;
                              case "ssn":
                                if (!/^[0-9]{9}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid ssn number (9 digits)";


                                }
                                break;
                              default:
                                // Handle unknown validationType or no specific validation required
                                break;
                            }

                            errorMessages[element.selectedOption] = errorMessage;
                            setValidationErrors(errorMessages);






                            handleChange(e, element, 'p', form?.id, 1)
                          }
                          }
                        />


                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>
                    )}
                    {element.elementType === "Date Picker" && (
                      <div>
                        <label className="question">{element?.name}</label>
                        {element.isMandatory &&
                          !accountData[element.selectedOption] &&
                          !accountDataObject[element.selectedOption] && (
                            <span className="error-message">
                              *
                            </span>
                          )}
                        <input
                          id={element.selectedOption}
                          type="date"
                          readOnly={element.isReadOnly}
                          min={minDateString}
                          max={maxDate}
                          name={element.selectedOption}
                          value={
                            formData[element.selectedOption]
                              ? formData[element.selectedOption]
                              : formDataObject[element.selectedOption]
                          }
                          onChange={(e) =>
                            handleChange(e, element, formIndex, form?.id, 1)
                          }
                        />

                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>
                    )}
                    {element.elementType == "Email" && (
                      <>
                        {language == 1 ? (
                          <div className="question">{element?.elementType}</div>
                        ) : (
                          <div className="question">Correo electrónico</div>
                        )}

                        <div>{userData?.PersonEmail}</div>
                      </>

                    )}
                    {element.elementType == "PhoneNumber" && (
                      <>

                        {language == 1 ? (
                          <div className="question">Cell Phone Number</div>
                        ) : (
                          <div className="question">Número Celular</div>
                        )}
                        <div>{userData?.Phone}</div>
                      </>

                    )}
                    {element.elementType == "PatientName" && ((() => {
                      formData[element.selectedOption] = userData?.Name;
                      return (
                        <>
                          <div>
                            <div>{language == 1 ? (
                              <label className="question">Patient Name</label>
                            ) : (
                              <label className="question">Nombre del Paciente</label>
                            )}
                              {element.isMandatory && !formData[element.selectedOption] && !formDataObject[element.selectedOption] && (
                                <span className="error-message">
                                  *
                                </span>
                              )}
                            </div>
                            <input
                              ref={inputRefs[element.selectedOption]}
                              type="text"
                              name={element.selectedOption}
                              value={formData[element.selectedOption] ? formData[element.selectedOption] : (formDataObject[element.selectedOption] || "")}
                              onChange={(e) =>
                                handleChange(e, element, formIndex, form?.id, 1)
                              }
                            />


                            {validationErrors[element.selectedOption] && (
                              <div className="error-message">
                                {validationErrors[element.selectedOption]}
                              </div>
                            )}
                          </div>
                        </>
                      )
                    })()
                    )}
                    {element.elementType === "Textarea" && (

                      <div>
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory && !formData[element.selectedOption] && !formDataObject[element.selectedOption] && (
                            <span className="error-message">
                              *
                            </span>
                          )}
                        </div>
                        <textarea
                          id={element.selectedOption}
                          name={element.selectedOption}
                          value={
                            formData[element.selectedOption]
                              ? formData[element.selectedOption]
                              : formDataObject[element.selectedOption] || ""
                          }
                          onChange={(e) => {
                            let errorMessages = {};
                            let errorMessage = '';

                            switch (element.validationType) {
                              case "email":
                                if (!/\S+@\S+\.\S+/.test(e.target.value)) {

                                  errorMessage = "Please enter a valid email";


                                }
                                break;
                              case "number":
                                if (isNaN(e.target.value)) {
                                  errorMessage = "Please enter a valid number";

                                }
                                break;
                              case "phone":
                                if (!/^[0-9]{10}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid phone number (10 digits)";


                                }
                                break;

                              case "cvv":
                                const cvvValue = e.target.value;
                                if (!/^[0-9]{3,4}$/.test(cvvValue)) {
                                  errorMessage = "Please enter a valid CVV (3 or 4 digits)";
                                  errorMessages[element.selectedOption] = errorMessage;
                                  setValidationErrors(errorMessages);
                                } else {
                                  // Clear any existing error message if input is valid
                                  delete errorMessages[element.selectedOption];
                                  setValidationErrors(errorMessages);
                                }
                                break;
                              case "ssn":
                                if (!/^[0-9]{9}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid ssn number (9 digits)";


                                }
                                break;
                              default:
                                // Handle unknown validationType or no specific validation required
                                break;
                            }

                            errorMessages[element.selectedOption] = errorMessage;
                            setValidationErrors(errorMessages);











                            handleChange(e, element, formIndex, form?.id, 1)
                          }}
                        ></textarea>
                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>
                    )}

                    {element.elementType == "PatientName And Date" && (
                      <div className="patientNameDate">
                        <div className="floatLeft">{userData?.Name}</div>
                        <div className="floatRight">{currentDate}</div>
                      </div>
                    )}

                    {element.elementType === "DateOfBirth" && (
                      <>
                        {language == 1 ? (
                          <div className="question">Date of Birth</div>
                        ) : (
                          <div className="question">Fecha de nacimiento</div>
                        )}


                        <div>
                          {/* Format the date */}
                          {userData?.Date_of_Birth__c &&
                            (() => {
                              const dateFromSalesforce = userData.Date_of_Birth__c;
                              const date = new Date(dateFromSalesforce);
                              const formattedDate = `${(date.getUTCMonth() + 1).toString().padStart(2, '0')}/${date.getUTCDate().toString().padStart(2, '0')}/${date.getUTCFullYear()}`; // Format the date as MM/DD/YYYY using UTC methods
                              return formattedDate;
                            })()
                          }

                        </div>

                      </>
                    )}

                    {element.elementType == "Weight" && (
                      <div key={element.id}>

                        <div>
                          <div className="half">
                            <div className="spacing5">
                              {language == 1 ? (
                                <label className="question">Weight (lbs)</label>
                              ) : (
                                <label className="question">Peso(Libras)</label>
                              )}

                              {element.isMandatory &&
                                !formData[element.selectedOption] &&
                                !formDataObject[element.selectedOption] && (
                                  <span className="error-message">
                                    *
                                  </span>
                                )}
                            </div>
                            <input
                              id={element.selectedOption}
                              name={element.selectedOption}
                              type="number"
                              readOnly={element.isReadOnly}
                              value={
                                formData[element.selectedOption]
                                  ? formData[element.selectedOption]
                                  : formDataObject[element.selectedOption] || ""
                              }
                              onChange={(e) => {
                                var value = e.target.value;
                                if (value === "" || parseFloat(value) >= 0 && parseFloat(value) <= 999) {
                                  handleChange(e, element, formIndex, form?.id, 1)
                                }
                                else {
                                  return;
                                }

                              }}
                            />
                            {validationErrors[element.selectedOption] && (
                              <div className="error-message">
                                {validationErrors[element.selectedOption]}
                              </div>
                            )}
                          </div>

                        </div>
                      </div>
                    )}
                    {element.elementType === "Height Field" && (
                      <div key={element.id}>
                        {language == 1 ? (
                          <div className="question">Height</div>
                        ) : (
                          <label className="question">Altura</label>
                        )}
                        <div>
                          <div className="half">
                            <div className="spacing5">
                              {language == 1 ? (
                                <label className="question">Feet</label>
                              ) : (
                                <label className="question">Pies</label>
                              )}

                              {element.isMandatory &&
                                !formData[element.selectedOption] &&
                                !formDataObject[element.selectedOption] && (
                                  <span className="error-message">
                                    *
                                  </span>
                                )}
                            </div>
                            <input
                              id={element.selectedOption}
                              name={element.selectedOption}
                              type="number"
                              readOnly={element.isReadOnly}
                              value={
                                formData[element.selectedOption]
                                  ? formData[element.selectedOption]
                                  : formDataObject[element.selectedOption] || ""
                              }
                              onChange={(e) => {
                                var value = e.target.value;
                                if (value === "" || parseFloat(value) >= 0 && parseFloat(value) <= 10) {
                                  handleChange(e, element, formIndex, form?.id, 1)
                                }
                                else {
                                  return;
                                }

                              }}
                            />
                            {validationErrors[element.selectedOption] && (
                              <div className="error-message">
                                {validationErrors[element.selectedOption]}
                              </div>
                            )}
                          </div>
                          <div className="half">
                            <div className="spacing5">
                              {language == 1 ? (
                                <div className="question">Inches</div>
                              ) : (
                                <label className="question">Pulgadas</label>
                              )}
                              {element.isMandatory &&
                                !formData[element.selectedOption] &&
                                !formDataObject[element.selectedOption] && (
                                  <span className="error-message">
                                    *
                                  </span>
                                )}

                            </div>
                            <input
                              name={element.selectedOption2}
                              type="number"
                              readOnly={element.isReadOnly}
                              value={
                                formData[element.selectedOption2]
                                  ? formData[element.selectedOption2]
                                  : formDataObject[element.selectedOption2] || ''
                              }
                              onChange={(e) => {
                                var value = e.target.value;
                                if (value >= 0 && value <= 11) {
                                  handleChange(e, element, formIndex, form?.id, 1)
                                }
                                else {
                                  return;
                                }
                              }
                              }


                            />

                            {validationErrors[element.selectedOption] && (
                              <div className="error-message">
                                {validationErrors[element.selectedOption]}
                              </div>
                            )}

                          </div>
                        </div>
                      </div>
                    )}

                    {element.elementType === "Checkbox" && (

                      <div class="conditionParent">
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !formData[element.selectedOption] &&
                            !formDataObject[element.selectedOption] && (
                              <span className="error-message">
                                *
                              </span>
                            )}
                        </div>
                        {element.options.map((option, optionIndex) => (
                          <div key={optionIndex} className="optionEntry">
                            <input
                              id={element.selectedOption}
                              type="checkbox"
                              name={element.selectedOption}
                              disabled={element.isReadOnly}
                              value={option}
                              onChange={(e) =>
                                handleChange(e, element, formIndex, form?.id, 1)
                              }
                              checked={
                                formData[element.selectedOption]
                                  ? formData[element.selectedOption] === option
                                  : formDataObject[element.selectedOption] ===
                                  option
                              }
                            />
                            <label id={element.selectedOption}>{option}</label>
                          </div>
                        ))}

                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                        {/* <div className="conditionalWrap"> */}
                        {element?.conditional?.length > 0 && renderConditionals(
        element,
        formIndex,
        form,
        formData,
        formDataObject,
        validationErrors,
        handleChange
      )}
                       </div>
                    )}
                    {element.elementType === "Radio Button" && (
                      <div>
                        <label className="question">{element?.name}</label>
                        {element.isMandatory &&
                          !formData[element.selectedOption] &&
                          !formDataObject[element.selectedOption] && (
                            <span className="error-message">*</span>
                          )}

                        {element.options.map((option, optionIndex) => (
                          <div key={optionIndex}>
                            <input
                              id={element.selectedOption}
                              type="radio"
                              name={element.selectedOption}
                              value={option}
                              disabled={element.isReadOnly}
                              onChange={(e) =>
                                handleChange(e, element, formIndex, form?.id, 1)
                              }
                              hecked={
                                formData[element.selectedOption]
                                  ? formData[element.selectedOption] === option
                                  : formDataObject[element.selectedOption] ===
                                  option
                              }
                            />
                            <label className="question">{option}</label>
                          </div>
                        ))}

                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>
                    )}
                    {element.elementType == "Dropdown" && (
                      <div className="dropdownStyle">
                        <div><label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !formData[element.selectedOption] &&
                            !formDataObject[element.selectedOption] && (
                              <span className="error-message">
                                *
                              </span>
                            )}
                        </div>
                        <select
                          id={element.selectedOption}
                          name={element.selectedOption}
                          value={formData[element.selectedOption] ||
                            formDataObject[element.selectedOption] || ""


                          }
                          onChange={(e) =>
                            handleChange(e, element, formIndex, form?.id, 1)
                          }
                        >
                          <option value="">{`Please Select`}</option>
                          {element.options.map((option, optionIndex) => (
                            <option key={optionIndex} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>


                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                           {element?.conditional?.length > 0 && renderConditionals(
        element,
        formIndex,
        form,
        formData,
        formDataObject,
        validationErrors,
        handleChange
      )}
                       
                      </div>
                    )}
                  </>
                </div>
              ))}
            </div>
          </form>
        </div>
      </div>
    </>
  );

  const renderConsentForm = (form, formIndex) => (
    <>
      <div className="contentWrap">
        <h3>{language == 1 ? form?.name : form.name_es}</h3>
        <div key={form?.id} className="form-container">

          <form>
            <div className={`pdf-content consent-content${formIndex}`}>
              {JSON.parse(language == 1 ? form?.formelements : form?.formelements_es).map((element, index) => (
                <div key={index} className={`form-element ${element.elementType === 'Text Field' ? 'fiftyByFifty' : ''}`}>

                  <>
                    {element.elementType === "MultiSelectCheckbox" && (
                      <>
                        <label className="question">{element?.name}</label>
                        <MultiSelect

                          element={element}
                          formDataObject={formDataObject}
                          setFormData={setFormData}
                          setChangedFormIds={setChangedFormIds}
                          setNormalFormIds={setNormalFormIds}
                          form={form}
                          formData={formData}


                        />
                      </>
                    )}
                    {element.elementType == "Payment" && (
                      <div>
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !accountData[element.selectedOption] &&
                            !accountDataObject[element.selectedOption] && (
                              <span className="error-message">
                                *
                              </span>
                            )}
                        </div>
                        <input
                          id={element.selectedOption}
                          type="text"
                          readOnly={element.isReadOnly}
                          name={element.selectedOption}
                          value={(accountData && accountData[element.selectedOption]) || (accountDataObject && accountDataObject[element.selectedOption]) || ''}
                          onChange={(e) => {
                            let errorMessages = {};
                            let errorMessage = '';

                            switch (element.validationType) {
                              case "email":
                                if (!/\S+@\S+\.\S+/.test(e.target.value)) {

                                  errorMessage = "Please enter a valid email";


                                }
                                break;
                              case "number":
                                if (isNaN(e.target.value)) {
                                  errorMessage = "Please enter a valid number";

                                }
                                break;
                              case "phone":
                                if (!/^[0-9]{10}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid phone number (10 digits)";


                                }
                                break;

                              case "cvv":
                                const cvvValue = e.target.value;
                                if (!/^[0-9]{3,4}$/.test(cvvValue)) {
                                  errorMessage = "Please enter a valid CVV (3 or 4 digits)";
                                  errorMessages[element.selectedOption] = errorMessage;
                                  setValidationErrors(errorMessages);
                                } else {
                                  // Clear any existing error message if input is valid
                                  delete errorMessages[element.selectedOption];
                                  setValidationErrors(errorMessages);
                                }
                                break;
                              case "ssn":
                                if (!/^[0-9]{9}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid ssn number (9 digits)";


                                }
                                break;
                              default:
                                // Handle unknown validationType or no specific validation required
                                break;
                            }

                            errorMessages[element.selectedOption] = errorMessage;
                            setValidationErrors(errorMessages);
                            handleChange(e, element, 'p', form?.id, 2)
                          }
                          } />
                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>
                    )}
                    {element.elementType == "cctype" && (
                      <>
                        <div className="dropdownStyle">
                          <div >
                            <label className="question">{element?.name}</label>
                            {element.isMandatory &&
                              !accountData[element.selectedOption] &&
                              !accountDataObject[element.selectedOption] && (
                                <span className="error-message">
                                  *
                                </span>
                              )}
                          </div>

                          <select
                            id={element.selectedOption}
                            name={element.selectedOption}
                            value={accountData[element.selectedOption] ||
                              accountDataObject[element.selectedOption] || ""


                            }
                            onChange={(e) =>
                              handleChange(e, element, 'p', form?.id, 2)
                            }
                          >
                            <option value="">{`Please Select`}</option>
                            {element.options.map((option, optionIndex) => (
                              <option key={optionIndex} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>

                          {validationErrors[element.selectedOption] && (
                            <div className="error-message">
                              {validationErrors[element.selectedOption]}
                            </div>
                          )}
                        </div>
                      </>

                    )}

                    {element.elementType == "ccdatepicker" && (
                      <div>
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !accountData[element.selectedOption] &&
                            !accountDataObject[element.selectedOption] && (
                              <span className="error-message">*</span>
                            )}
                        </div>


                        <input
                          id={element.selectedOption}
                          type="month"

                          name={element.selectedOption}
                          readOnly={element.isReadOnly}
                          value={
                            accountData[element.selectedOption]
                              ? accountData[element.selectedOption]
                              : accountDataObject[element.selectedOption]
                          }
                          onChange={(e) =>
                            handleChange(e, element, 'p', form.id, 2)
                          }
                        />

                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>
                    )}
                    {element.elementType == "Address" && (
                      <div>
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !formData[element.selectedOption] &&
                            !formDataObject[element.selectedOption] && (
                              <span className="error-message">*</span>
                            )}
                        </div>
                        {/*                         <input
                          id={element.selectedOption}
                          type="text"
                          name={element.selectedOption}
                          readOnly={element.isReadOnly}
                          value={
                            formData[element.selectedOption]
                              ? formData[element.selectedOption]
                              : formDataObject[element.selectedOption] || ""
                          }
                          onChange={(e) =>
                            handleChange(e, element, formIndex, form?.id, 1)
                          }
                        /> */}
                        <GooglePlacesAutocomplete
                          apiKey="AIzaSyBBKKQMuAlA8rlwlDBSyWyRvgz0chj5blM"
                          onPlaceSelected={(place) => {
                            if (place && place.formatted_address) {
                              setFormData((prevFormData) => ({
                                ...prevFormData,
                                [element.selectedOption]: place.formatted_address,
                              }));
                              //alert(place.formatted_address);
                            }
                          }}
                          options={{
                            types: ['address'], // Specify the types of places to be restricted (optional)
                            componentRestrictions: { country: 'us' }, // Restrict the search to a specific country (optional)
                          }}
                          style={{ width: '100%' }}
                        />
                      </div>
                    )}
                    {/* Other input types */}

                    {element.elementType === "ConsentTextarea" && element?.content && (
                      (() => {
                        // Compute the data variable
                        var data = element.content.replace(
                          /\$(Name|InsuranceCompany)/g,
                          (match, p1) =>
                            p1 === "Name"
                              ? userData?.Name || ""
                              : formData["HQ_Insurance_Carrier_Name__c"]
                                ? formData["HQ_Insurance_Carrier_Name__c"]
                                : formDataObject["HQ_Insurance_Carrier_Name__c"] || ""
                        );
                        data = data.replace(/\$Input/g, '<input type="text" />');

                        // Return JSX with the computed data
                        return (
                          <div
                            dangerouslySetInnerHTML={{ __html: data }}
                          />
                        );
                      })()
                    )}

                    {element.elementType === "Textarea" && (
                      <div>
                        <label className="question">{element?.name}</label>
                        {element.isMandatory &&
                          !formData[element.selectedOption] &&
                          !formDataObject[element.selectedOption] && (
                            <span className="error-message">*</span>
                          )}

                        <textarea
                          id={element.selectedOption}
                          name={element.selectedOption}
                          value={
                            formData[element.selectedOption]
                              ? formData[element.selectedOption]
                              : formDataObject[element.selectedOption] || ""
                          }
                          onChange={(e) => {
                            let errorMessages = {};
                            let errorMessage = '';

                            switch (element.validationType) {
                              case "email":
                                if (!/\S+@\S+\.\S+/.test(e.target.value)) {

                                  errorMessage = "Please enter a valid email";


                                }
                                break;
                              case "number":
                                if (isNaN(e.target.value)) {
                                  errorMessage = "Please enter a valid number";

                                }
                                break;
                              case "phone":
                                if (!/^[0-9]{10}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid phone number (10 digits)";


                                }
                                break;

                              case "cvv":
                                if (!/^[0-9]{3}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid cvv (3 digits)";


                                }
                                break;
                              case "ssn":
                                if (!/^[0-9]{9}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid ssn number (9 digits)";


                                }
                                break;
                              default:
                                // Handle unknown validationType or no specific validation required
                                break;
                            }

                            errorMessages[element.selectedOption] = errorMessage;
                            setValidationErrors(errorMessages);



                            handleChange(e, element, formIndex, form?.id, 2)
                          }}
                        ></textarea>

                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>
                    )}
                    {element.elementType == "ConsentTextField" && (
                      <div>
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !formData[element.selectedOption] &&
                            !formDataObject[element.selectedOption] && (
                              <div className="error-message">*</div>
                            )}
                        </div>
                        <input
                          id={element.selectedOption}
                          type={element.validationType == 'phone' || element.validationType == 'number' ? 'number' : "text"}
                          readOnly={element.isReadOnly}
                          name={element.selectedOption}
                          value={
                            formData[element.selectedOption]
                              ? formData[element.selectedOption]
                              : formDataObject[element.selectedOption] || ""
                          }
                          onChange={(e) => {
                            let errorMessages = {};
                            let errorMessage = '';

                            switch (element.validationType) {
                              case "email":
                                if (!/\S+@\S+\.\S+/.test(e.target.value)) {

                                  errorMessage = "Please enter a valid email";


                                }
                                break;
                              case "number":
                                if (isNaN(e.target.value)) {
                                  errorMessage = "Please enter a valid number";

                                }
                                break;
                              case "phone":
                                if (!/^[0-9]{10}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid phone number (10 digits)";


                                }
                                break;

                              case "cvv":
                                if (!/^[0-9]{3}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid cvv (3 digits)";


                                }
                                break;
                              case "ssn":
                                if (!/^[0-9]{9}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid ssn number (9 digits)";


                                }
                                break;
                              default:
                                // Handle unknown validationType or no specific validation required
                                break;
                            }

                            errorMessages[element.selectedOption] = errorMessage;
                            setValidationErrors(errorMessages);



                            handleChange(e, element, formIndex, form?.id, 2)
                          }}
                        />

                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>
                    )}
                    {element.elementType == "Text Field" && (
                      <div>
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !formData[element.selectedOption] &&
                            !formDataObject[element.selectedOption] && (
                              <div className="error-message">*</div>
                            )}
                        </div>
                        <input
                          id={element.selectedOption}
                          type={element.validationType == 'phone' || element.validationType == 'number' ? 'number' : "text"}
                          name={element.selectedOption}
                          readOnly={element.isReadOnly}
                          value={
                            formData[element.selectedOption]
                              ? formData[element.selectedOption]
                              : formDataObject[element.selectedOption] || ""
                          }
                          onChange={(e) => {
                            let errorMessages = {};
                            let errorMessage = '';

                            switch (element.validationType) {
                              case "email":
                                if (!/\S+@\S+\.\S+/.test(e.target.value)) {

                                  errorMessage = "Please enter a valid email";


                                }
                                break;
                              case "number":
                                if (isNaN(e.target.value)) {
                                  errorMessage = "Please enter a valid number";

                                }
                                break;
                              case "phone":
                                if (!/^[0-9]{10}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid phone number (10 digits)";


                                }
                                break;

                              case "cvv":
                                if (!/^[0-9]{3}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid cvv (3 digits)";


                                }
                                break;
                              case "ssn":
                                if (!/^[0-9]{9}$/.test(e.target.value)) {
                                  errorMessage =
                                    "Please enter a valid ssn number (9 digits)";


                                }
                                break;
                              default:
                                // Handle unknown validationType or no specific validation required
                                break;
                            }

                            errorMessages[element.selectedOption] = errorMessage;
                            setValidationErrors(errorMessages);




                            handleChange(e, element, formIndex, form?.id, 2)
                          }}
                        />

                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>
                    )}
                    {element.elementType === "Date Picker" && (
                      <div>
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !formData[element.selectedOption] &&
                            !formDataObject[element.selectedOption] && (
                              <span className="error-message">*</span>
                            )}
                        </div>
                        <input
                          id={element.selectedOption}
                          type="date"
                          min={minDateString}
                          max={maxDate}
                          name={element.selectedOption}
                          readOnly={element.isReadOnly}
                          value={
                            formData[element.selectedOption]
                              ? formData[element.selectedOption]
                              : formDataObject[element.selectedOption]
                          }
                          onChange={(e) =>
                            handleChange(e, element, formIndex, form.id, 2)
                          }
                        />

                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                      </div>
                    )}

                    {element.elementType == "ConsentCheckbox" && (
                      <>
                        <input type="checkbox" />
                        <label className="question">{element.label}</label>
                      </>
                    )}
                    {element.elementType === "Checkbox" && (
                      <div class="conditionParent">
                        <div>
                          <label className="question">{element?.name}</label>
                          {element.isMandatory &&
                            !formData[element.selectedOption] &&
                            !formDataObject[element.selectedOption] && (
                              <span className="error-message">
                                *
                              </span>
                            )}
                        </div>
                        {element.options.map((option, optionIndex) => (
                          <div key={optionIndex} className="optionEntry">
                            <input
                              id={element.selectedOption}
                              type="checkbox"
                              name={element.selectedOption}
                              value={option}

                              disabled={element.isReadOnly}
                              onChange={(e) =>

                                handleChange(e, element, formIndex, form?.id, 2)
                              }
                              checked={
                                formData[element.selectedOption]
                                  ? formData[element.selectedOption] === option
                                  : formDataObject[element.selectedOption] ===
                                  option
                              }
                            />
                            <label>{option}</label>
                          </div>
                        ))}

                        {validationErrors[element.selectedOption] && (
                          <div className="error-message">
                            {validationErrors[element.selectedOption]}
                          </div>
                        )}
                        {/* <div className="conditionalWrap"> */}
                        {element?.conditional?.map((condition, index) => {
                          if (
                            formData[element.selectedOption]
                              ? condition.selectedConditionalOption ==
                              formData[element.selectedOption]
                              : condition.selectedConditionalOption ==
                              formDataObject[element.selectedOption]
                          ) {


                            if (condition.elementType == "ConsentTextarea" && condition?.content) {

                              // Compute the data variable
                              var data = condition.content.replace(
                                /\$(Name|InsuranceCompany)/g,
                                (match, p1) =>
                                  p1 === "Name"
                                    ? userData?.Name || ""
                                    : formData["HQ_Insurance_Carrier_Name__c"]
                                      ? formData["HQ_Insurance_Carrier_Name__c"]
                                      : formDataObject["HQ_Insurance_Carrier_Name__c"] || ""
                              );
                              data = data.replace(/\$Input/g, '<input type="text" />');

                              // Return JSX with the computed data
                              return (
                                <div
                                  dangerouslySetInnerHTML={{ __html: data }}
                                />
                              );
                            }
                            if (condition.elementType == "Text Field") {
                              return (
                                <div className="conditionalWrap">
                                  <label className="question">
                                    {condition?.name}
                                  </label>
                                  {condition.isMandatory &&
                                    !formData[condition.selectedOption] &&
                                    !formDataObject[
                                    condition.selectedOption
                                    ] && <div className="error-message">*</div>}

                                  <input
                                    id={condition.selectedOption}
                                    type={condition.validationType == 'phone' || condition.validationType == 'number' ? 'number' : "text"}
                                    name={condition.selectedOption}
                                    readOnly={condition.isReadOnly}
                                    value={
                                      formData[condition.selectedOption]
                                        ? formData[condition.selectedOption]
                                        : formDataObject[
                                        condition.selectedOption
                                        ] || ""
                                    }
                                    onChange={(e) => {
                                      let errorMessages = {};
                                      let errorMessage = '';

                                      switch (condition.validationType) {
                                        case "email":
                                          if (!/\S+@\S+\.\S+/.test(e.target.value)) {

                                            errorMessage = "Please enter a valid email";


                                          }
                                          break;
                                        case "number":
                                          if (isNaN(e.target.value)) {
                                            errorMessage = "Please enter a valid number";

                                          }
                                          break;
                                        case "phone":
                                          if (!/^[0-9]{10}$/.test(e.target.value)) {
                                            errorMessage =
                                              "Please enter a valid phone number (10 digits)";


                                          }
                                          break;

                                        case "cvv":
                                          if (!/^[0-9]{3}$/.test(e.target.value)) {
                                            errorMessage =
                                              "Please enter a valid cvv (3 digits)";


                                          }
                                          break;
                                        case "ssn":
                                          if (!/^[0-9]{9}$/.test(e.target.value)) {
                                            errorMessage =
                                              "Please enter a valid ssn number (9 digits)";


                                          }
                                          break;
                                        default:
                                          // Handle unknown validationType or no specific validation required
                                          break;
                                      }

                                      errorMessages[condition.selectedOption] = errorMessage;
                                      setValidationErrors(errorMessages);



                                      handleChange(
                                        e,
                                        condition,
                                        formIndex,
                                        form?.id,
                                        2
                                      )
                                    }}
                                  />
                                  {condition.isMandatory &&
                                    !formData[condition.selectedOption] &&
                                    !formDataObject[
                                    condition.selectedOption
                                    ] && (
                                      <div className="error-message">
                                        *{condition?.name}Mandatory
                                      </div>
                                    )}
                                  {validationErrors[
                                    condition.selectedOption
                                  ] && (
                                      <div className="error-message">
                                        {
                                          validationErrors[
                                          condition.selectedOption
                                          ]
                                        }
                                      </div>
                                    )}
                                </div>
                              );
                            }



                            if (condition.elementType == "ConsentTextField") {
                              return (
                                <div className="conditionalWrap">
                                  <label className="question">
                                    {condition?.name}
                                  </label>
                                  {condition.isMandatory &&
                                    !formData[condition.selectedOption] &&
                                    !formDataObject[
                                    condition.selectedOption
                                    ] && <div className="error-message">*</div>}

                                  <input
                                    id={condition.selectedOption}
                                    type={condition.validationType == 'phone' || condition.validationType == 'number' ? 'number' : "text"}
                                    name={condition.selectedOption}
                                    readOnly={condition.isReadOnly}
                                    value={
                                      formData[condition.selectedOption]
                                        ? formData[condition.selectedOption]
                                        : formDataObject[
                                        condition.selectedOption
                                        ] || ""
                                    }
                                    onChange={(e) => {
                                      let errorMessages = {};
                                      let errorMessage = '';

                                      switch (condition.validationType) {
                                        case "email":
                                          if (!/\S+@\S+\.\S+/.test(e.target.value)) {

                                            errorMessage = "Please enter a valid email";


                                          }
                                          break;
                                        case "number":
                                          if (isNaN(e.target.value)) {
                                            errorMessage = "Please enter a valid number";

                                          }
                                          break;
                                        case "phone":
                                          if (!/^[0-9]{10}$/.test(e.target.value)) {
                                            errorMessage =
                                              "Please enter a valid phone number (10 digits)";


                                          }
                                          break;

                                        case "cvv":
                                          if (!/^[0-9]{3}$/.test(e.target.value)) {
                                            errorMessage =
                                              "Please enter a valid cvv (3 digits)";


                                          }
                                          break;
                                        case "ssn":
                                          if (!/^[0-9]{9}$/.test(e.target.value)) {
                                            errorMessage =
                                              "Please enter a valid ssn number (9 digits)";


                                          }
                                          break;
                                        default:
                                          // Handle unknown validationType or no specific validation required
                                          break;
                                      }

                                      errorMessages[condition.selectedOption] = errorMessage;
                                      setValidationErrors(errorMessages);



                                      handleChange(
                                        e,
                                        condition,
                                        formIndex,
                                        form?.id,
                                        2
                                      )
                                    }}
                                  />
                                  {condition.isMandatory &&
                                    !formData[condition.selectedOption] &&
                                    !formDataObject[
                                    condition.selectedOption
                                    ] && (
                                      <div className="error-message">
                                        *{condition?.name}Mandatory
                                      </div>
                                    )}
                                  {validationErrors[
                                    condition.selectedOption
                                  ] && (
                                      <div className="error-message">
                                        {
                                          validationErrors[
                                          condition.selectedOption
                                          ]
                                        }
                                      </div>
                                    )}
                                </div>
                              );
                            }

                            if (condition.elementType == "Textarea") {
                              return (
                                <div className="conditionalWrap">
                                  <label className="question">
                                    {condition?.name}
                                  </label>
                                  {condition.isMandatory &&
                                    !formData[condition.selectedOption] &&
                                    !formDataObject[
                                    condition.selectedOption
                                    ] && (
                                      <span className="error-message">*</span>
                                    )}

                                  <input
                                    id={condition.selectedOption}
                                    type="text"
                                    name={condition.selectedOption}
                                    readOnly={condition.isReadOnly}
                                    value={
                                      formData[condition.selectedOption]
                                        ? formData[condition.selectedOption]
                                        : formDataObject[
                                        condition.selectedOption
                                        ] || ""
                                    }
                                    onChange={(e) => {
                                      let errorMessages = {};
                                      let errorMessage = '';

                                      switch (condition.validationType) {
                                        case "email":
                                          if (!/\S+@\S+\.\S+/.test(e.target.value)) {

                                            errorMessage = "Please enter a valid email";


                                          }
                                          break;
                                        case "number":
                                          if (isNaN(e.target.value)) {
                                            errorMessage = "Please enter a valid number";

                                          }
                                          break;
                                        case "phone":
                                          if (!/^[0-9]{10}$/.test(e.target.value)) {
                                            errorMessage =
                                              "Please enter a valid phone number (10 digits)";


                                          }
                                          break;

                                        case "cvv":
                                          if (!/^[0-9]{3}$/.test(e.target.value)) {
                                            errorMessage =
                                              "Please enter a valid cvv (3 digits)";


                                          }
                                          break;
                                        case "ssn":
                                          if (!/^[0-9]{9}$/.test(e.target.value)) {
                                            errorMessage =
                                              "Please enter a valid ssn number (9 digits)";


                                          }
                                          break;
                                        default:
                                          // Handle unknown validationType or no specific validation required
                                          break;
                                      }

                                      errorMessages[condition.selectedOption] = errorMessage;
                                      setValidationErrors(errorMessages);



                                      handleChange(
                                        e,
                                        condition,
                                        formIndex,
                                        form?.id,
                                        2
                                      )
                                    }}
                                  />
                                  {condition.isMandatory &&
                                    !formData[condition.selectedOption] &&
                                    !formDataObject[
                                    condition.selectedOption
                                    ] && (
                                      <div className="error-message">
                                        *{condition?.name}Mandatory
                                      </div>
                                    )}
                                  {validationErrors[
                                    condition.selectedOption
                                  ] && (
                                      <div className="error-message">
                                        {
                                          validationErrors[
                                          condition.selectedOption
                                          ]
                                        }
                                      </div>
                                    )}
                                </div>
                              );
                            }
                            if (condition.elementType == "Date Picker") {
                              return (
                                <div className="conditionalWrap">
                                  <label className="question">
                                    {condition?.name}
                                  </label>
                                  {element.isMandatory &&
                                    !formData[element.selectedOption] &&
                                    !formDataObject[element.selectedOption] && (
                                      <span className="error-message">*</span>
                                    )}

                                  <input
                                    id={condition.selectedOption}
                                    type="date"
                                    readOnly={condition.isReadOnly}
                                    min={minDateString}
                                    max={maxDate}
                                    name={condition.selectedOption}
                                    value={
                                      formData[condition.selectedOption]
                                        ? formData[condition.selectedOption]
                                        : formDataObject[
                                        condition.selectedOption
                                        ]
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        e,
                                        condition,
                                        formIndex,
                                        form?.id,
                                        2
                                      )
                                    }
                                  />
                                  {condition.isMandatory &&
                                    !formData[condition.selectedOption] &&
                                    !formDataObject[
                                    condition.selectedOption
                                    ] && (
                                      <div className="error-message">
                                        *{condition?.name}Mandatory
                                      </div>
                                    )}
                                  {validationErrors[
                                    condition.selectedOption
                                  ] && (
                                      <div className="error-message">
                                        {
                                          validationErrors[
                                          condition.selectedOption
                                          ]
                                        }
                                      </div>
                                    )}
                                </div>
                              );
                            }
                            if (condition.elementType == "Checkbox") {
                              return (
                                <div className="conditionalWrap">
                                  <label className="question">
                                    {condition?.name}
                                  </label>
                                  {condition?.options.map(
                                    (option, optionIndex) => (
                                      <div key={optionIndex} className="optionEntry">
                                        <input
                                          id={condition.selectedOption}
                                          type="checkbox"
                                          name={condition.selectedOption}
                                          value={option}
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              condition,
                                              formIndex,
                                              form?.id,
                                              2
                                            )
                                          }
                                          checked={
                                            formData[condition.selectedOption]
                                              ? formData[
                                              condition.selectedOption
                                              ] === option
                                              : formDataObject[
                                              condition.selectedOption
                                              ] === option
                                          }
                                        />
                                        <label className="question">
                                          {option}
                                        </label>
                                      </div>
                                    )
                                  )}
                                  {condition.isMandatory &&
                                    !formData[condition.selectedOption] &&
                                    !formDataObject[
                                    condition.selectedOption
                                    ] && (
                                      <div className="error-message">
                                        *{condition?.name}Mandatory
                                      </div>
                                    )}
                                  {validationErrors[
                                    condition.selectedOption
                                  ] && (
                                      <div className="error-message">
                                        {
                                          validationErrors[
                                          condition.selectedOption
                                          ]
                                        }
                                      </div>
                                    )}
                                </div>
                              );
                            }
                          }
                        })}
                      </div>
                       )}
                    {element.elementType == "PatientName" && (
                      <>
                        <div className="question">{element.elementType}</div>
                        <div>{userData?.Name}</div>
                      </>
                    )}
                    {element.elementType == "PatientName And Date" && (
                      <div className="patientNameDate">
                        <div className="floatLeft">{userData?.Name}</div>
                        <div className="floatRight">{currentDate}</div>
                      </div>
                    )}
                    {element.elementType == "Email" && (
                      <>

                        <div className="question">{element?.elementType}</div>
                        <div>{userData?.PersonEmail}</div>
                      </>
                    )}
                    {element.elementType == "PhoneNumber" && (
                      <>
                        {language == 1 ? (
                          <div className="question">Cell Phone Number</div>
                        ) : (
                          <div className="question">Número Celular</div>
                        )}
                        <div>{userData?.Phone}</div>
                      </>
                    )}
                    {element.elementType == "Signature" && (
                      <>
                        <div className="question">{element.name}</div>
                        <div style={{ width: '400px', height: '200px', border: '1px solid black' }}></div>
                      </>
                    )}
                    {element.elementType === "DateOfBirth" && (
                      <>
                        <div className="question">Date of Birth</div>
                        <div>
                          {/* Format the date */}
                          {userData?.Date_of_Birth__c &&
                            (() => {
                              const dateFromSalesforce = userData.Date_of_Birth__c;
                              const date = new Date(dateFromSalesforce);
                              const formattedDate = `${(date.getUTCMonth() + 1).toString().padStart(2, '0')}/${date.getUTCDate().toString().padStart(2, '0')}/${date.getUTCFullYear()}`; // Format the date as MM/DD/YYYY using UTC methods
                              return formattedDate;
                            })()
                          }
                        </div>
                      </>
                    )}
                  </>
                </div>
              ))}
            </div>
          </form>
        </div>
        <>
          {signaturevalue && (
            <>
              <div class="patientSign">Patient/Guardian Signature</div>
              <div>
                <img src={signaturevalue} alt="User Signature" />
              </div>
            </>
          )}
        </>
      </div>
      <div className="formCheck">
        <div key={formIndex}>
          <input
            type="checkbox"
            checked={form.checked}
            disabled={form.checked}
            onChange={() => updateCheckboxState(formIndex)}
          />
          {language == 1 ? (
            <label>By checking the box I acknowledge and agree to conduct business electronically, that I have read the terms of the above section, and that I agree to insert my electronic signature as set forth below indicating my consent to terms set forth on this page. </label>
          ) : (
            <label>Al marcar la casilla, reconozco y acepto realizar negocios electrónicamente, que he leído los términos de la sección anterior y que acepto insertar mi firma electrónica como se establece a continuación, indicando mi consentimiento a los términos establecidos en esta página. </label>
          )}
        </div>
      </div>
    </>
  );
  return (
    <div>
      <div class="headerWrapper">
        <div className="header">
          <div className="imageContainer">
            <img src={logo} alt="Logo" />
          </div>
        </div>
      </div>
      <div className="userCss">
        <div id="toastContainer">
          <Toaster />
        </div>
        <div className={`modal ${continueModal ? 'show' : ''}`}>
          <div className="modal-content">
            {language == 1 ? (
              <>
                <h2>Do You Want To Continue Or Restart Your Application</h2>
                <button onClick={(e) => { setContinueModal(false) }}>Continue</button>
                <button onClick={(e) => ClearAll(e)}>Clear</button>
              </>
            ) : (
              <>
                <h2>¿Quiere continuar o reiniciar su aplicación?</h2>
                <button onClick={(e) => { setContinueModal(false) }}>Continuar</button>
                <button onClick={(e) => ClearAll(e)}>Clara</button>
              </>
            )}
          </div>
        </div>
        <div className={`modal ${showModal ? 'show' : ''}`}>
          <div className="modal-content">
            <span className="close" onClick={() => setShowModal(false)}>&times;</span>
            {language == 1 ? (
              <p>Please do not close this window. Your application is uploading,  you will be notified when the upload is complete.</p>
            ) : (
              <p>Por favor no cierre esta ventana. Su solicitud se está cargando, se le notificará cuando se complete la carga.</p>
            )}
          </div>
        </div>
        <div className={`modal ${okModal ? 'show' : ''}`}>
          <div className="modal-content">
            <span className="close" onClick={() => setOkModal(false)}>&times;</span>
            {ok == 1 ? (
              <>
                {language == 1 ? (
                  <>
                    <h2>Forms Successfully Submitted...</h2>
                    <p> Kindly take a moment to carefully review the terms and conditions detailed on the next page as well as check the box at the bottom of each section. Once reviewed, please proceed to sign and provide your consent at the bottom of the page.</p>
                  </>
                ) : (
                  <>
                    <h2>Formularios enviados exitosamente...</h2>
                    <p> Tómese un momento para revisar detenidamente los términos y condiciones que se detallan en la página siguiente y marque la casilla al final de cada sección. Una vez revisado, proceda a firmar y brindar su consentimiento en la parte inferior de la página.</p>
                  </>
                )}
                <button onClick={handleNext}>OK</button>
              </>
            ) : (
              <>
                {language == 1 ? (
                  <p>Forms are Successfully Submitted...</p>
                ) : (
                  <p>Los formularios se enviaron correctamente...</p>
                )}
                <button onClick={(e) => logout1(e)}>OK</button>
              </>
            )}
          </div>
        </div>
        {consentFlag ? (
          <>
            {consentForms?.map((form, index) => {
              var formvalue;
              if (form.formConditionalvalue) {
                var parsedFormConditionalValue = JSON.parse(form?.formConditionalvalue);
                formvalue = parsedFormConditionalValue?.value
              }
              return (
                <div key={index}>
                  {!formDataObject[formvalue] && (
                    <div className="userFormWrap">
                      {renderConsentForm(form, index)}
                    </div>
                  )}
                </div>
              );
            })}
            {language == 1 ? (
              <label>Signature ( Please Sign )</label>
            ) : (
              <label>Firma (Por favor firme)</label>
            )}
            <>
              {signaturevalue ? (
                <div>
                  <img src={signaturevalue} alt="User Signature" />
                </div>
              ) : (
                <>
                  <SignatureDialog
                    signatureRef={signatureRef}
                    setSignatureRef={setSignatureRef}
                  />
                </>
              )}
              <div>
                <div className="button sidebutton" onClick={(e) => handleClear(e)}>
                  {language == 1 ? (
                    <p>Clear</p>
                  ) : (
                    <p>Clara</p>
                  )}
                </div>
              </div>
            </>
            <input
              type="checkbox"
              onChange={(e) => {
                logEvent('Consent Check box selected');
                if (e.target.checked == true) {
                  formData['HQ_Privacy_Response__c'] = 'Accepted';
                  formData['HQ_Consent_for_Marketing_Mails__c'] = 'Yes I consent to receive communication from the Company via automated phone calls and/or text messages (SMS and MMS) for educational marketing advertising appointment scheduling and appointment reminder purposes at these phone numbers';
                } else {
                  formData['HQ_Privacy_Response__c'] = 'Declined';
                  formData['HQ_Consent_for_Marketing_Mails__c'] = 'No I do not consent to receive automated phone calls or text messages from the Company'
                }
                setTerms(e.target.checked)
              }}
            />
            {language == 1 ? (
              <label>By selecting [Adopt and Sign], I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts</label>
            ) : (
              <label> Al seleccionar [Adoptar y firmar], acepto que la firma y las iniciales serán la representación electrónica de mi firma y mis iniciales para todos los fines cuando yo (o mi agente) las utilicemos en documentos, incluidos contratos legalmente vinculantes.</label>
            )}
          </>
        ) : (
          <>
            {normalForms?.map((form, index) => {
              const isMotorVehicleAccident = (
                (formData && formData['HQ_Motor_Vehiclle_Accident_Relevance__c'] === 'Motor vehicle accident') ||
                (formDataObject && formDataObject['HQ_Motor_Vehiclle_Accident_Relevance__c'] === 'Motor vehicle accident') || ""
              );
              const isExcludedForm = ['Irrevocable Practice Lien-patient Financial Agreement', 'Assignment Of Benefits Form'].includes(form.name);
              if (!isExcludedForm || isMotorVehicleAccident) {
                return (
                  <div key={index}>
                    <div className="userFormWrap">{renderForm(form, index)}</div>
                  </div>
                );
              }
              return null; // Hide excluded forms when condition is met
            })}
            {signaturevalue && (
              <>
                <div>Patient/Guardian Signature</div>
                <div>
                  <img src={signaturevalue} alt="User Signature" />
                </div>
              </>
            )}
          </>
        )}

        {consentFlag ? (
          <div class="buttonWrapper">
            {singleTerms && terms ? (
              <button
                type="submit"
                className="button"
                onClick={(e) => handleSubmit(e, 2)}
              >
                {language == 1 ? (
                  <label className="question">Submit</label>
                ) : (
                  <label className="question">Entregar</label>
                )}
              </button>
            ) : (
              <button
                type="submit"
                className="button"
                style={{ background: 'gray' }}
              >
                {language == 1 ? (
                  <label className="question">Submit</label>
                ) : (
                  <label className="question">Entregar</label>
                )}
              </button>
            )}
          </div>
        ) : (
          <div className="buttonWrapper">
            <button
              type="submit"
              className="button"
              onClick={(e) => handleSubmit(e, 1)}
            >
              {language == 1 ? (
                <label className="question">Submit</label>
              ) : (
                <label className="question">Entregar</label>
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default User;